/* tslint:disable */
/* eslint-disable */
/**
 * LabBase API
 * LabBase Apiサーバースキーマ
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Admin
 */
export interface Admin {
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    'userDetailUuid': string;
    /**
     * 
     * @type {number}
     * @memberof Admin
     */
    'roleId': number;
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    'lastLoginAt': string;
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof Admin
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Admin
     */
    'registered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Admin
     */
    'paidFlag': boolean;
    /**
     * 
     * @type {Role}
     * @memberof Admin
     */
    'role': Role;
    /**
     * 
     * @type {UGC}
     * @memberof Admin
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface Bookmark
 */
export interface Bookmark {
    /**
     * 
     * @type {string}
     * @memberof Bookmark
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Bookmark
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Bookmark
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof Bookmark
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Bookmark
     */
    'materialGroupUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Bookmark
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Bookmark
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof Bookmark
     */
    'deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof Bookmark
     */
    'sort': number;
    /**
     * 
     * @type {UGC}
     * @memberof Bookmark
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface Card
 */
export interface Card {
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'object': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'address_city': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'address_country': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'address_line1': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'address_line1_check': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'address_line2': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'address_state': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'address_zip': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'address_zip_check': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'brand': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'customer': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'cvc_check': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'dynamic_last4': string;
    /**
     * 
     * @type {number}
     * @memberof Card
     */
    'exp_month': number;
    /**
     * 
     * @type {number}
     * @memberof Card
     */
    'exp_year': number;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'fingerprint': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'funding': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'last4': string;
    /**
     * 
     * @type {object}
     * @memberof Card
     */
    'metadata': object;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    'tokenization_method': string;
}
/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'slug': string;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'parentId': number;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'ugcUuid': string;
    /**
     * 
     * @type {UGC}
     * @memberof Category
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface CategoryList
 */
export interface CategoryList {
    /**
     * 
     * @type {Array<Category>}
     * @memberof CategoryList
     */
    'categories': Array<Category>;
}
/**
 * 
 * @export
 * @interface CompleteMaterial
 */
export interface CompleteMaterial {
    /**
     * 
     * @type {string}
     * @memberof CompleteMaterial
     */
    'userDetailUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteMaterial
     */
    'materialUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteMaterial
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteMaterial
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface CompleteMaterialGroup
 */
export interface CompleteMaterialGroup {
    /**
     * 
     * @type {string}
     * @memberof CompleteMaterialGroup
     */
    'userDetailUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteMaterialGroup
     */
    'materialGroupUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteMaterialGroup
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteMaterialGroup
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Contacts
 */
export interface Contacts {
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface Conversation
 */
export interface Conversation {
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'userUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'adminUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'createdAt': string;
    /**
     * 
     * @type {User}
     * @memberof Conversation
     */
    'user': User;
    /**
     * 
     * @type {Admin}
     * @memberof Conversation
     */
    'admin': Admin;
}
/**
 * 
 * @export
 * @interface ConversationByAdmin
 */
export interface ConversationByAdmin {
    /**
     * 
     * @type {string}
     * @memberof ConversationByAdmin
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationByAdmin
     */
    'userUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationByAdmin
     */
    'adminUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationByAdmin
     */
    'createdAt': string;
    /**
     * 
     * @type {User}
     * @memberof ConversationByAdmin
     */
    'user': User;
    /**
     * 
     * @type {Admin}
     * @memberof ConversationByAdmin
     */
    'admin': Admin;
    /**
     * 
     * @type {Array<Message>}
     * @memberof ConversationByAdmin
     */
    'messages': Array<Message>;
}
/**
 * 
 * @export
 * @interface ConversationByOrganizationAdmin
 */
export interface ConversationByOrganizationAdmin {
    /**
     * 
     * @type {string}
     * @memberof ConversationByOrganizationAdmin
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationByOrganizationAdmin
     */
    'userUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationByOrganizationAdmin
     */
    'adminUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationByOrganizationAdmin
     */
    'organizationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationByOrganizationAdmin
     */
    'createdAt': string;
    /**
     * 
     * @type {OrganizationUser}
     * @memberof ConversationByOrganizationAdmin
     */
    'user': OrganizationUser;
    /**
     * 
     * @type {Admin}
     * @memberof ConversationByOrganizationAdmin
     */
    'admin': Admin;
    /**
     * 
     * @type {Array<Message>}
     * @memberof ConversationByOrganizationAdmin
     */
    'messages': Array<Message>;
}
/**
 * 
 * @export
 * @interface Coupon
 */
export interface Coupon {
    /**
     * 
     * @type {string}
     * @memberof Coupon
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Coupon
     */
    'object': string;
    /**
     * 
     * @type {number}
     * @memberof Coupon
     */
    'amount_off': number;
    /**
     * 
     * @type {number}
     * @memberof Coupon
     */
    'created': number;
    /**
     * 
     * @type {string}
     * @memberof Coupon
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof Coupon
     */
    'duration': string;
    /**
     * 
     * @type {number}
     * @memberof Coupon
     */
    'duration_in_months': number;
    /**
     * 
     * @type {boolean}
     * @memberof Coupon
     */
    'livemode': boolean;
    /**
     * 
     * @type {number}
     * @memberof Coupon
     */
    'max_redemptions': number;
    /**
     * 
     * @type {object}
     * @memberof Coupon
     */
    'metadata': object;
    /**
     * 
     * @type {string}
     * @memberof Coupon
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Coupon
     */
    'percent_off': number;
    /**
     * 
     * @type {number}
     * @memberof Coupon
     */
    'redeem_by': number;
    /**
     * 
     * @type {number}
     * @memberof Coupon
     */
    'times_redeemed': number;
    /**
     * 
     * @type {boolean}
     * @memberof Coupon
     */
    'volid': boolean;
}
/**
 * 
 * @export
 * @interface CreateCard
 */
export interface CreateCard {
    /**
     * 
     * @type {string}
     * @memberof CreateCard
     */
    'cusId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateCard
     */
    'number': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCard
     */
    'exp_month': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCard
     */
    'exp_year': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCard
     */
    'cvc': number;
}
/**
 * 
 * @export
 * @interface CreateCustomer
 */
export interface CreateCustomer {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomer
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomer
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomer
     */
    'metadata'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomer
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface CreatePaymentMethods
 */
export interface CreatePaymentMethods {
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentMethods
     */
    'cusId': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentMethods
     */
    'paymentMethodId': string;
}
/**
 * 
 * @export
 * @interface CreateSubscription
 */
export interface CreateSubscription {
    /**
     * 
     * @type {string}
     * @memberof CreateSubscription
     */
    'cusId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscription
     */
    'planId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateSubscription
     */
    'trialEndDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscription
     */
    'trialEndNow'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscription
     */
    'couId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscription
     */
    'promoCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscription
     */
    'userUuid': string;
}
/**
 * 
 * @export
 * @interface CreatedConversation
 */
export interface CreatedConversation {
    /**
     * 
     * @type {string}
     * @memberof CreatedConversation
     */
    'userUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedConversation
     */
    'adminUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedConversation
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedConversation
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface CreatedMaterial
 */
export interface CreatedMaterial {
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterial
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterial
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterial
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterial
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterial
     */
    'materialGroupUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterial
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterial
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedMaterial
     */
    'deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatedMaterial
     */
    'sort': number;
    /**
     * 
     * @type {Array<MaterialGroup>}
     * @memberof CreatedMaterial
     */
    'materialGroup': Array<MaterialGroup>;
    /**
     * 
     * @type {UGC}
     * @memberof CreatedMaterial
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface CreatedMaterialGroup
 */
export interface CreatedMaterialGroup {
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterialGroup
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterialGroup
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterialGroup
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterialGroup
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedMaterialGroup
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedMaterialGroup
     */
    'deleted': boolean;
    /**
     * 
     * @type {Array<Category>}
     * @memberof CreatedMaterialGroup
     */
    'categories': Array<Category>;
    /**
     * 
     * @type {UGC}
     * @memberof CreatedMaterialGroup
     */
    'ugc': UGC;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedMaterialGroup
     */
    'visibilityFlag': boolean;
}
/**
 * 
 * @export
 * @interface Customer
 */
export interface Customer {
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'object': string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'address': string;
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    'created': number;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'default_source': string;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    'delinquent': boolean;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'description': string;
    /**
     * 
     * @type {object}
     * @memberof Customer
     */
    'discount': object;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'invoice_prefix': string;
    /**
     * 
     * @type {object}
     * @memberof Customer
     */
    'invoice_settings': object;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    'livemode': boolean;
    /**
     * 
     * @type {object}
     * @memberof Customer
     */
    'metadata': object;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    'next_invoice_sequence': number;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'phone': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Customer
     */
    'preferred_locales': Array<string>;
    /**
     * 
     * @type {object}
     * @memberof Customer
     */
    'shipping': object;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'tax_exempt': string;
}
/**
 * 
 * @export
 * @interface DeleteCard
 */
export interface DeleteCard {
    /**
     * 
     * @type {string}
     * @memberof DeleteCard
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCard
     */
    'object': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeleteCard
     */
    'deleted': boolean;
}
/**
 * 
 * @export
 * @interface DeleteCustomer
 */
export interface DeleteCustomer {
    /**
     * 
     * @type {string}
     * @memberof DeleteCustomer
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCustomer
     */
    'object': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeleteCustomer
     */
    'deleted': boolean;
}
/**
 * 
 * @export
 * @interface Discount
 */
export interface Discount {
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'object': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'checkout_session': string;
    /**
     * 
     * @type {Coupon}
     * @memberof Discount
     */
    'coupon': Coupon;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'customer': string;
    /**
     * 
     * @type {number}
     * @memberof Discount
     */
    'end': number;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'invoice': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'invoice_item': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'promotion_code': string;
    /**
     * 
     * @type {number}
     * @memberof Discount
     */
    'start': number;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'subscription': string;
}
/**
 * 
 * @export
 * @interface EmailWithConfirm
 */
export interface EmailWithConfirm {
    /**
     * 
     * @type {string}
     * @memberof EmailWithConfirm
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EmailWithConfirm
     */
    'confirmEmail': string;
}
/**
 * 
 * @export
 * @interface EnvelopedAdmin
 */
export interface EnvelopedAdmin {
    /**
     * 
     * @type {EnvelopedAdminData}
     * @memberof EnvelopedAdmin
     */
    'data': EnvelopedAdminData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedAdmin
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedAdminAndToken
 */
export interface EnvelopedAdminAndToken {
    /**
     * 
     * @type {EnvelopedAdminAndTokenData}
     * @memberof EnvelopedAdminAndToken
     */
    'data': EnvelopedAdminAndTokenData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedAdminAndToken
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedAdminAndTokenData
 */
export interface EnvelopedAdminAndTokenData {
    /**
     * 
     * @type {Admin}
     * @memberof EnvelopedAdminAndTokenData
     */
    'admin'?: Admin;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedAdminAndTokenData
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedAdminData
 */
export interface EnvelopedAdminData {
    /**
     * 
     * @type {Admin}
     * @memberof EnvelopedAdminData
     */
    'admin'?: Admin;
}
/**
 * 
 * @export
 * @interface EnvelopedBookmark
 */
export interface EnvelopedBookmark {
    /**
     * 
     * @type {EnvelopedBookmarkData}
     * @memberof EnvelopedBookmark
     */
    'data': EnvelopedBookmarkData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedBookmark
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedBookmarkData
 */
export interface EnvelopedBookmarkData {
    /**
     * 
     * @type {Bookmark}
     * @memberof EnvelopedBookmarkData
     */
    'bookmark'?: Bookmark;
}
/**
 * 
 * @export
 * @interface EnvelopedCategory
 */
export interface EnvelopedCategory {
    /**
     * 
     * @type {EnvelopedCategoryData}
     * @memberof EnvelopedCategory
     */
    'data': EnvelopedCategoryData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedCategory
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedCategoryData
 */
export interface EnvelopedCategoryData {
    /**
     * 
     * @type {Category}
     * @memberof EnvelopedCategoryData
     */
    'category'?: Category;
}
/**
 * 
 * @export
 * @interface EnvelopedCategoryList
 */
export interface EnvelopedCategoryList {
    /**
     * 
     * @type {CategoryList}
     * @memberof EnvelopedCategoryList
     */
    'data': CategoryList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedCategoryList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedCompleteMaterial
 */
export interface EnvelopedCompleteMaterial {
    /**
     * 
     * @type {EnvelopedCompleteMaterialData}
     * @memberof EnvelopedCompleteMaterial
     */
    'data': EnvelopedCompleteMaterialData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedCompleteMaterial
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedCompleteMaterialData
 */
export interface EnvelopedCompleteMaterialData {
    /**
     * 
     * @type {CompleteMaterial}
     * @memberof EnvelopedCompleteMaterialData
     */
    'completeMaterial'?: CompleteMaterial;
}
/**
 * 
 * @export
 * @interface EnvelopedCompleteMaterialGroup
 */
export interface EnvelopedCompleteMaterialGroup {
    /**
     * 
     * @type {EnvelopedCompleteMaterialGroupData}
     * @memberof EnvelopedCompleteMaterialGroup
     */
    'data': EnvelopedCompleteMaterialGroupData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedCompleteMaterialGroup
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedCompleteMaterialGroupData
 */
export interface EnvelopedCompleteMaterialGroupData {
    /**
     * 
     * @type {CompleteMaterialGroup}
     * @memberof EnvelopedCompleteMaterialGroupData
     */
    'completeMaterialGroup'?: CompleteMaterialGroup;
}
/**
 * 
 * @export
 * @interface EnvelopedConversation
 */
export interface EnvelopedConversation {
    /**
     * 
     * @type {EnvelopedConversationData}
     * @memberof EnvelopedConversation
     */
    'data': EnvelopedConversationData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedConversation
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedConversationData
 */
export interface EnvelopedConversationData {
    /**
     * 
     * @type {Conversation}
     * @memberof EnvelopedConversationData
     */
    'conversation'?: Conversation;
}
/**
 * 
 * @export
 * @interface EnvelopedCouponList
 */
export interface EnvelopedCouponList {
    /**
     * 
     * @type {string}
     * @memberof EnvelopedCouponList
     */
    'object'?: string;
    /**
     * 
     * @type {Array<Coupon>}
     * @memberof EnvelopedCouponList
     */
    'data'?: Array<Coupon>;
    /**
     * 
     * @type {boolean}
     * @memberof EnvelopedCouponList
     */
    'has_more'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedCouponList
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedCreatedConversation
 */
export interface EnvelopedCreatedConversation {
    /**
     * 
     * @type {EnvelopedCreatedConversationData}
     * @memberof EnvelopedCreatedConversation
     */
    'data': EnvelopedCreatedConversationData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedCreatedConversation
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedCreatedConversationData
 */
export interface EnvelopedCreatedConversationData {
    /**
     * 
     * @type {CreatedConversation}
     * @memberof EnvelopedCreatedConversationData
     */
    'conversation'?: CreatedConversation;
}
/**
 * 
 * @export
 * @interface EnvelopedCreatedMaterialGroup
 */
export interface EnvelopedCreatedMaterialGroup {
    /**
     * 
     * @type {EnvelopedCreatedMaterialGroupData}
     * @memberof EnvelopedCreatedMaterialGroup
     */
    'data'?: EnvelopedCreatedMaterialGroupData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedCreatedMaterialGroup
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedCreatedMaterialGroupData
 */
export interface EnvelopedCreatedMaterialGroupData {
    /**
     * 
     * @type {CreatedMaterialGroup}
     * @memberof EnvelopedCreatedMaterialGroupData
     */
    'materialGroup'?: CreatedMaterialGroup;
}
/**
 * 
 * @export
 * @interface EnvelopedGetNewMessageCount
 */
export interface EnvelopedGetNewMessageCount {
    /**
     * 
     * @type {GetNewMessageCount}
     * @memberof EnvelopedGetNewMessageCount
     */
    'data': GetNewMessageCount;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedGetNewMessageCount
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedMaterial
 */
export interface EnvelopedMaterial {
    /**
     * 
     * @type {EnvelopedMaterialData}
     * @memberof EnvelopedMaterial
     */
    'data': EnvelopedMaterialData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedMaterial
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedMaterialData
 */
export interface EnvelopedMaterialData {
    /**
     * 
     * @type {CreatedMaterial}
     * @memberof EnvelopedMaterialData
     */
    'material'?: CreatedMaterial;
}
/**
 * 
 * @export
 * @interface EnvelopedMaterialGroup
 */
export interface EnvelopedMaterialGroup {
    /**
     * 
     * @type {EnvelopedMaterialGroupData}
     * @memberof EnvelopedMaterialGroup
     */
    'data': EnvelopedMaterialGroupData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedMaterialGroup
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedMaterialGroupData
 */
export interface EnvelopedMaterialGroupData {
    /**
     * 
     * @type {MaterialGroup}
     * @memberof EnvelopedMaterialGroupData
     */
    'materialGroup': MaterialGroup;
}
/**
 * 
 * @export
 * @interface EnvelopedMessage
 */
export interface EnvelopedMessage {
    /**
     * 
     * @type {EnvelopedMessageData}
     * @memberof EnvelopedMessage
     */
    'data': EnvelopedMessageData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedMessage
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedMessageData
 */
export interface EnvelopedMessageData {
    /**
     * 
     * @type {Message}
     * @memberof EnvelopedMessageData
     */
    'message'?: Message;
}
/**
 * 
 * @export
 * @interface EnvelopedNews
 */
export interface EnvelopedNews {
    /**
     * 
     * @type {EnvelopedNewsData}
     * @memberof EnvelopedNews
     */
    'data': EnvelopedNewsData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedNews
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedNewsData
 */
export interface EnvelopedNewsData {
    /**
     * 
     * @type {News}
     * @memberof EnvelopedNewsData
     */
    'news'?: News;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganization
 */
export interface EnvelopedOrganization {
    /**
     * 
     * @type {EnvelopedOrganizationData}
     * @memberof EnvelopedOrganization
     */
    'data': EnvelopedOrganizationData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedOrganization
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganizationAdmin
 */
export interface EnvelopedOrganizationAdmin {
    /**
     * 
     * @type {EnvelopedOrganizationAdminData}
     * @memberof EnvelopedOrganizationAdmin
     */
    'data': EnvelopedOrganizationAdminData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedOrganizationAdmin
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganizationAdminAndToken
 */
export interface EnvelopedOrganizationAdminAndToken {
    /**
     * 
     * @type {EnvelopedOrganizationAdminAndTokenData}
     * @memberof EnvelopedOrganizationAdminAndToken
     */
    'data': EnvelopedOrganizationAdminAndTokenData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedOrganizationAdminAndToken
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganizationAdminAndTokenData
 */
export interface EnvelopedOrganizationAdminAndTokenData {
    /**
     * 
     * @type {OrganizationAdmin}
     * @memberof EnvelopedOrganizationAdminAndTokenData
     */
    'organizationAdmin'?: OrganizationAdmin;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedOrganizationAdminAndTokenData
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganizationAdminData
 */
export interface EnvelopedOrganizationAdminData {
    /**
     * 
     * @type {OrganizationAdmin}
     * @memberof EnvelopedOrganizationAdminData
     */
    'organizationAdmin': OrganizationAdmin;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganizationData
 */
export interface EnvelopedOrganizationData {
    /**
     * 
     * @type {Organization}
     * @memberof EnvelopedOrganizationData
     */
    'organization': Organization;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganizationUser
 */
export interface EnvelopedOrganizationUser {
    /**
     * 
     * @type {EnvelopedOrganizationUserData}
     * @memberof EnvelopedOrganizationUser
     */
    'data': EnvelopedOrganizationUserData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedOrganizationUser
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganizationUserAndToken
 */
export interface EnvelopedOrganizationUserAndToken {
    /**
     * 
     * @type {EnvelopedOrganizationUserAndTokenData}
     * @memberof EnvelopedOrganizationUserAndToken
     */
    'data': EnvelopedOrganizationUserAndTokenData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedOrganizationUserAndToken
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganizationUserAndTokenData
 */
export interface EnvelopedOrganizationUserAndTokenData {
    /**
     * 
     * @type {OrganizationUser}
     * @memberof EnvelopedOrganizationUserAndTokenData
     */
    'organizationUser'?: OrganizationUser;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedOrganizationUserAndTokenData
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedOrganizationUserData
 */
export interface EnvelopedOrganizationUserData {
    /**
     * 
     * @type {OrganizationUser}
     * @memberof EnvelopedOrganizationUserData
     */
    'organizationUser': OrganizationUser;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedAdminList
 */
export interface EnvelopedPaginatedAdminList {
    /**
     * 
     * @type {PaginatedAdminList}
     * @memberof EnvelopedPaginatedAdminList
     */
    'data': PaginatedAdminList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedAdminList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedCompleteMaterialGroupList
 */
export interface EnvelopedPaginatedCompleteMaterialGroupList {
    /**
     * 
     * @type {EnvelopedPaginatedCompleteMaterialGroupListData}
     * @memberof EnvelopedPaginatedCompleteMaterialGroupList
     */
    'data': EnvelopedPaginatedCompleteMaterialGroupListData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedCompleteMaterialGroupList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedCompleteMaterialGroupListData
 */
export interface EnvelopedPaginatedCompleteMaterialGroupListData {
    /**
     * 
     * @type {PaginatedCompleteMaterialGroupList}
     * @memberof EnvelopedPaginatedCompleteMaterialGroupListData
     */
    'completeMaterialGroup': PaginatedCompleteMaterialGroupList;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedCompleteMaterialList
 */
export interface EnvelopedPaginatedCompleteMaterialList {
    /**
     * 
     * @type {EnvelopedPaginatedCompleteMaterialListData}
     * @memberof EnvelopedPaginatedCompleteMaterialList
     */
    'data': EnvelopedPaginatedCompleteMaterialListData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedCompleteMaterialList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedCompleteMaterialListData
 */
export interface EnvelopedPaginatedCompleteMaterialListData {
    /**
     * 
     * @type {PaginatedCompleteMaterialList}
     * @memberof EnvelopedPaginatedCompleteMaterialListData
     */
    'completeMaterial': PaginatedCompleteMaterialList;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedConversation
 */
export interface EnvelopedPaginatedConversation {
    /**
     * 
     * @type {PaginatedConversation}
     * @memberof EnvelopedPaginatedConversation
     */
    'data': PaginatedConversation;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedConversation
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedConversationByAdmin
 */
export interface EnvelopedPaginatedConversationByAdmin {
    /**
     * 
     * @type {PaginatedConversationByAdmin}
     * @memberof EnvelopedPaginatedConversationByAdmin
     */
    'data': PaginatedConversationByAdmin;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedConversationByAdmin
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedConversationByOrganizationAdmin
 */
export interface EnvelopedPaginatedConversationByOrganizationAdmin {
    /**
     * 
     * @type {PaginatedConversationByOrganizationAdmin}
     * @memberof EnvelopedPaginatedConversationByOrganizationAdmin
     */
    'data': PaginatedConversationByOrganizationAdmin;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedConversationByOrganizationAdmin
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedMaterialGroupList
 */
export interface EnvelopedPaginatedMaterialGroupList {
    /**
     * 
     * @type {PaginatedMaterialGroupList}
     * @memberof EnvelopedPaginatedMaterialGroupList
     */
    'data': PaginatedMaterialGroupList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedMaterialGroupList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedMaterialList
 */
export interface EnvelopedPaginatedMaterialList {
    /**
     * 
     * @type {PaginatedMaterialList}
     * @memberof EnvelopedPaginatedMaterialList
     */
    'data': PaginatedMaterialList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedMaterialList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedMessageList
 */
export interface EnvelopedPaginatedMessageList {
    /**
     * 
     * @type {MessageList}
     * @memberof EnvelopedPaginatedMessageList
     */
    'data': MessageList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedMessageList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedNewsList
 */
export interface EnvelopedPaginatedNewsList {
    /**
     * 
     * @type {PaginatedNewsList}
     * @memberof EnvelopedPaginatedNewsList
     */
    'data'?: PaginatedNewsList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedNewsList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedOrganizationAdminList
 */
export interface EnvelopedPaginatedOrganizationAdminList {
    /**
     * 
     * @type {PaginatedOrganizationAdminList}
     * @memberof EnvelopedPaginatedOrganizationAdminList
     */
    'data': PaginatedOrganizationAdminList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedOrganizationAdminList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedOrganizationList
 */
export interface EnvelopedPaginatedOrganizationList {
    /**
     * 
     * @type {PaginatedOrganizationList}
     * @memberof EnvelopedPaginatedOrganizationList
     */
    'data': PaginatedOrganizationList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedOrganizationList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedOrganizationUserList
 */
export interface EnvelopedPaginatedOrganizationUserList {
    /**
     * 
     * @type {PaginatedOrganizationUserList}
     * @memberof EnvelopedPaginatedOrganizationUserList
     */
    'data': PaginatedOrganizationUserList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedOrganizationUserList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedUGCList
 */
export interface EnvelopedPaginatedUGCList {
    /**
     * 
     * @type {PaginatedUGCList}
     * @memberof EnvelopedPaginatedUGCList
     */
    'data': PaginatedUGCList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedUGCList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaginatedUserList
 */
export interface EnvelopedPaginatedUserList {
    /**
     * 
     * @type {PaginatedUserList}
     * @memberof EnvelopedPaginatedUserList
     */
    'data': PaginatedUserList;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaginatedUserList
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPatchReadFlag
 */
export interface EnvelopedPatchReadFlag {
    /**
     * 
     * @type {PatchReadFlag}
     * @memberof EnvelopedPatchReadFlag
     */
    'data': PatchReadFlag;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPatchReadFlag
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPaymentList
 */
export interface EnvelopedPaymentList {
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaymentList
     */
    'object': string;
    /**
     * 
     * @type {Array<Payment>}
     * @memberof EnvelopedPaymentList
     */
    'data': Array<Payment>;
    /**
     * 
     * @type {boolean}
     * @memberof EnvelopedPaymentList
     */
    'has_more': boolean;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPaymentList
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPlanList
 */
export interface EnvelopedPlanList {
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPlanList
     */
    'object': string;
    /**
     * 
     * @type {Array<Plan>}
     * @memberof EnvelopedPlanList
     */
    'data': Array<Plan>;
    /**
     * 
     * @type {boolean}
     * @memberof EnvelopedPlanList
     */
    'has_more': boolean;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPlanList
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPreAdminAndToken
 */
export interface EnvelopedPreAdminAndToken {
    /**
     * 
     * @type {EnvelopedPreAdminAndTokenData}
     * @memberof EnvelopedPreAdminAndToken
     */
    'data': EnvelopedPreAdminAndTokenData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPreAdminAndToken
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPreAdminAndTokenData
 */
export interface EnvelopedPreAdminAndTokenData {
    /**
     * 
     * @type {PreAdmin}
     * @memberof EnvelopedPreAdminAndTokenData
     */
    'admin'?: PreAdmin;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPreAdminAndTokenData
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedPreUserAndToken
 */
export interface EnvelopedPreUserAndToken {
    /**
     * 
     * @type {EnvelopedPreUserAndTokenData}
     * @memberof EnvelopedPreUserAndToken
     */
    'data': EnvelopedPreUserAndTokenData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPreUserAndToken
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPreUserAndTokenData
 */
export interface EnvelopedPreUserAndTokenData {
    /**
     * 
     * @type {PreUser}
     * @memberof EnvelopedPreUserAndTokenData
     */
    'user'?: PreUser;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPreUserAndTokenData
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedPresentMaterials
 */
export interface EnvelopedPresentMaterials {
    /**
     * 
     * @type {EnvelopedPresentMaterialsData}
     * @memberof EnvelopedPresentMaterials
     */
    'data': EnvelopedPresentMaterialsData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPresentMaterials
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPresentMaterialsData
 */
export interface EnvelopedPresentMaterialsData {
    /**
     * 
     * @type {Array<Material>}
     * @memberof EnvelopedPresentMaterialsData
     */
    'material'?: Array<Material>;
}
/**
 * 
 * @export
 * @interface EnvelopedProductList
 */
export interface EnvelopedProductList {
    /**
     * 
     * @type {string}
     * @memberof EnvelopedProductList
     */
    'object': string;
    /**
     * 
     * @type {Array<Product>}
     * @memberof EnvelopedProductList
     */
    'data': Array<Product>;
    /**
     * 
     * @type {boolean}
     * @memberof EnvelopedProductList
     */
    'has_more': boolean;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedProductList
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface EnvelopedPromoList
 */
export interface EnvelopedPromoList {
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPromoList
     */
    'object'?: string;
    /**
     * 
     * @type {Array<Promo>}
     * @memberof EnvelopedPromoList
     */
    'data'?: Array<Promo>;
    /**
     * 
     * @type {boolean}
     * @memberof EnvelopedPromoList
     */
    'has_more'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedPromoList
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedResetPasswordResponse
 */
export interface EnvelopedResetPasswordResponse {
    /**
     * 
     * @type {ResetPasswordResponse}
     * @memberof EnvelopedResetPasswordResponse
     */
    'data': ResetPasswordResponse;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedResetPasswordResponse
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedSetPasswordResponseByAdmin
 */
export interface EnvelopedSetPasswordResponseByAdmin {
    /**
     * 
     * @type {EnvelopedAdminData}
     * @memberof EnvelopedSetPasswordResponseByAdmin
     */
    'data': EnvelopedAdminData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedSetPasswordResponseByAdmin
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedSetPasswordResponseByOrganizationAdmin
 */
export interface EnvelopedSetPasswordResponseByOrganizationAdmin {
    /**
     * 
     * @type {EnvelopedSetPasswordResponseByOrganizationAdminData}
     * @memberof EnvelopedSetPasswordResponseByOrganizationAdmin
     */
    'data': EnvelopedSetPasswordResponseByOrganizationAdminData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedSetPasswordResponseByOrganizationAdmin
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedSetPasswordResponseByOrganizationAdminData
 */
export interface EnvelopedSetPasswordResponseByOrganizationAdminData {
    /**
     * 
     * @type {OrganizationAdmin}
     * @memberof EnvelopedSetPasswordResponseByOrganizationAdminData
     */
    'admin'?: OrganizationAdmin;
}
/**
 * 
 * @export
 * @interface EnvelopedSetPasswordResponseByOrganizationUser
 */
export interface EnvelopedSetPasswordResponseByOrganizationUser {
    /**
     * 
     * @type {EnvelopedSetPasswordResponseByOrganizationUserData}
     * @memberof EnvelopedSetPasswordResponseByOrganizationUser
     */
    'data': EnvelopedSetPasswordResponseByOrganizationUserData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedSetPasswordResponseByOrganizationUser
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedSetPasswordResponseByOrganizationUserData
 */
export interface EnvelopedSetPasswordResponseByOrganizationUserData {
    /**
     * 
     * @type {OrganizationUser}
     * @memberof EnvelopedSetPasswordResponseByOrganizationUserData
     */
    'organizationUser'?: OrganizationUser;
}
/**
 * 
 * @export
 * @interface EnvelopedSetPasswordResponseByUser
 */
export interface EnvelopedSetPasswordResponseByUser {
    /**
     * 
     * @type {EnvelopedSetPasswordResponseByUserData}
     * @memberof EnvelopedSetPasswordResponseByUser
     */
    'data': EnvelopedSetPasswordResponseByUserData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedSetPasswordResponseByUser
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedSetPasswordResponseByUserData
 */
export interface EnvelopedSetPasswordResponseByUserData {
    /**
     * 
     * @type {User}
     * @memberof EnvelopedSetPasswordResponseByUserData
     */
    'user'?: User;
}
/**
 * 
 * @export
 * @interface EnvelopedSortedMaterialGroups
 */
export interface EnvelopedSortedMaterialGroups {
    /**
     * 
     * @type {EnvelopedSortedMaterialGroupsData}
     * @memberof EnvelopedSortedMaterialGroups
     */
    'data': EnvelopedSortedMaterialGroupsData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedSortedMaterialGroups
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedSortedMaterialGroupsData
 */
export interface EnvelopedSortedMaterialGroupsData {
    /**
     * 
     * @type {EnvelopedSortedMaterialGroupsDataMaterialGroup}
     * @memberof EnvelopedSortedMaterialGroupsData
     */
    'materialGroup': EnvelopedSortedMaterialGroupsDataMaterialGroup;
}
/**
 * 
 * @export
 * @interface EnvelopedSortedMaterialGroupsDataMaterialGroup
 */
export interface EnvelopedSortedMaterialGroupsDataMaterialGroup {
    /**
     * 
     * @type {MaterialGroup}
     * @memberof EnvelopedSortedMaterialGroupsDataMaterialGroup
     */
    'targetMaterialGroup'?: MaterialGroup;
    /**
     * 
     * @type {Array<MaterialGroup>}
     * @memberof EnvelopedSortedMaterialGroupsDataMaterialGroup
     */
    'notTargetMaterialGroup'?: Array<MaterialGroup>;
}
/**
 * 
 * @export
 * @interface EnvelopedSortedMaterials
 */
export interface EnvelopedSortedMaterials {
    /**
     * 
     * @type {EnvelopedSortedMaterialsData}
     * @memberof EnvelopedSortedMaterials
     */
    'data': EnvelopedSortedMaterialsData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedSortedMaterials
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedSortedMaterialsData
 */
export interface EnvelopedSortedMaterialsData {
    /**
     * 
     * @type {EnvelopedSortedMaterialsDataMaterial}
     * @memberof EnvelopedSortedMaterialsData
     */
    'material'?: EnvelopedSortedMaterialsDataMaterial;
}
/**
 * 
 * @export
 * @interface EnvelopedSortedMaterialsDataMaterial
 */
export interface EnvelopedSortedMaterialsDataMaterial {
    /**
     * 
     * @type {Material}
     * @memberof EnvelopedSortedMaterialsDataMaterial
     */
    'targetMaterial'?: Material;
    /**
     * 
     * @type {Array<Material>}
     * @memberof EnvelopedSortedMaterialsDataMaterial
     */
    'notTargetMaterial'?: Array<Material>;
}
/**
 * 
 * @export
 * @interface EnvelopedSubscriptionList
 */
export interface EnvelopedSubscriptionList {
    /**
     * 
     * @type {string}
     * @memberof EnvelopedSubscriptionList
     */
    'object': string;
    /**
     * 
     * @type {Array<Subscription>}
     * @memberof EnvelopedSubscriptionList
     */
    'data': Array<Subscription>;
    /**
     * 
     * @type {boolean}
     * @memberof EnvelopedSubscriptionList
     */
    'has_more': boolean;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedSubscriptionList
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface EnvelopedToken
 */
export interface EnvelopedToken {
    /**
     * 
     * @type {Token}
     * @memberof EnvelopedToken
     */
    'data': Token;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedToken
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedUGC
 */
export interface EnvelopedUGC {
    /**
     * 
     * @type {EnvelopedUGCData}
     * @memberof EnvelopedUGC
     */
    'data': EnvelopedUGCData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedUGC
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedUGCData
 */
export interface EnvelopedUGCData {
    /**
     * 
     * @type {UGC}
     * @memberof EnvelopedUGCData
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface EnvelopedUser
 */
export interface EnvelopedUser {
    /**
     * 
     * @type {EnvelopedUserData}
     * @memberof EnvelopedUser
     */
    'data': EnvelopedUserData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedUser
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedUserAndToken
 */
export interface EnvelopedUserAndToken {
    /**
     * 
     * @type {EnvelopedUserAndTokenData}
     * @memberof EnvelopedUserAndToken
     */
    'data': EnvelopedUserAndTokenData;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedUserAndToken
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface EnvelopedUserAndTokenData
 */
export interface EnvelopedUserAndTokenData {
    /**
     * 
     * @type {User}
     * @memberof EnvelopedUserAndTokenData
     */
    'user'?: User;
    /**
     * 
     * @type {string}
     * @memberof EnvelopedUserAndTokenData
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface EnvelopedUserData
 */
export interface EnvelopedUserData {
    /**
     * 
     * @type {User}
     * @memberof EnvelopedUserData
     */
    'user': User;
}
/**
 * 
 * @export
 * @interface GetNewMessageCount
 */
export interface GetNewMessageCount {
    /**
     * 
     * @type {number}
     * @memberof GetNewMessageCount
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface LoginBody
 */
export interface LoginBody {
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface Material
 */
export interface Material {
    /**
     * 
     * @type {string}
     * @memberof Material
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Material
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Material
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof Material
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Material
     */
    'materialGroupUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Material
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Material
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof Material
     */
    'deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof Material
     */
    'sort': number;
    /**
     * 
     * @type {UGC}
     * @memberof Material
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface MaterialGroup
 */
export interface MaterialGroup {
    /**
     * 
     * @type {string}
     * @memberof MaterialGroup
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroup
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroup
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroup
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroup
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof MaterialGroup
     */
    'deleted': boolean;
    /**
     * 
     * @type {Array<Material>}
     * @memberof MaterialGroup
     */
    'materials': Array<Material>;
    /**
     * 
     * @type {Array<Category>}
     * @memberof MaterialGroup
     */
    'categories': Array<Category>;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroup
     */
    'planId': string;
    /**
     * 
     * @type {UGC}
     * @memberof MaterialGroup
     */
    'ugc': UGC;
    /**
     * 
     * @type {boolean}
     * @memberof MaterialGroup
     */
    'visibilityFlag': boolean;
}
/**
 * 
 * @export
 * @interface MaterialGroupList
 */
export interface MaterialGroupList {
    /**
     * 
     * @type {string}
     * @memberof MaterialGroupList
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroupList
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroupList
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroupList
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroupList
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof MaterialGroupList
     */
    'deleted': boolean;
    /**
     * 
     * @type {Array<Material>}
     * @memberof MaterialGroupList
     */
    'materials': Array<Material>;
    /**
     * 
     * @type {Array<Category>}
     * @memberof MaterialGroupList
     */
    'categories': Array<Category>;
    /**
     * 
     * @type {string}
     * @memberof MaterialGroupList
     */
    'planId': string;
    /**
     * 
     * @type {UGC}
     * @memberof MaterialGroupList
     */
    'ugc': UGC;
    /**
     * 
     * @type {boolean}
     * @memberof MaterialGroupList
     */
    'visibilityFlag': boolean;
}
/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'conversationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'senderUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'uuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    'readFlag': boolean;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface MessageList
 */
export interface MessageList {
    /**
     * 
     * @type {Array<Message>}
     * @memberof MessageList
     */
    'items': Array<Message>;
    /**
     * 
     * @type {number}
     * @memberof MessageList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface MulterFileInfo
 */
export interface MulterFileInfo {
    /**
     * 
     * @type {string}
     * @memberof MulterFileInfo
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof MulterFileInfo
     */
    'originalname': string;
    /**
     * 
     * @type {string}
     * @memberof MulterFileInfo
     */
    'encoding': string;
    /**
     * 
     * @type {string}
     * @memberof MulterFileInfo
     */
    'mimetype': string;
    /**
     * 
     * @type {string}
     * @memberof MulterFileInfo
     */
    'fieldname': string;
    /**
     * 
     * @type {string}
     * @memberof MulterFileInfo
     */
    'destination': string;
    /**
     * 
     * @type {string}
     * @memberof MulterFileInfo
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof MulterFileInfo
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface NewCategory
 */
export interface NewCategory {
    /**
     * 
     * @type {string}
     * @memberof NewCategory
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof NewCategory
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NewCategory
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof NewCategory
     */
    'ugcUuid'?: string;
}
/**
 * 
 * @export
 * @interface NewConversations
 */
export interface NewConversations {
    /**
     * 
     * @type {string}
     * @memberof NewConversations
     */
    'userUuid': string;
    /**
     * 
     * @type {string}
     * @memberof NewConversations
     */
    'adminUuid': string;
    /**
     * 
     * @type {string}
     * @memberof NewConversations
     */
    'organizationUuid'?: string;
}
/**
 * 
 * @export
 * @interface NewMaterial
 */
export interface NewMaterial {
    /**
     * 
     * @type {Array<NewMaterialMaterialGroup>}
     * @memberof NewMaterial
     */
    'materialGroup': Array<NewMaterialMaterialGroup>;
    /**
     * 
     * @type {string}
     * @memberof NewMaterial
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NewMaterial
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof NewMaterial
     */
    'ugcUuid'?: string;
}
/**
 * 
 * @export
 * @interface NewMaterialGroup
 */
export interface NewMaterialGroup {
    /**
     * 
     * @type {string}
     * @memberof NewMaterialGroup
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NewMaterialGroup
     */
    'ugcUuid'?: string;
    /**
     * 
     * @type {Array<NewMaterialGroupCategories>}
     * @memberof NewMaterialGroup
     */
    'categories'?: Array<NewMaterialGroupCategories>;
    /**
     * 
     * @type {string}
     * @memberof NewMaterialGroup
     */
    'planId': string;
    /**
     * 
     * @type {boolean}
     * @memberof NewMaterialGroup
     */
    'visibilityFlag': boolean;
}
/**
 * 
 * @export
 * @interface NewMaterialGroupCategories
 */
export interface NewMaterialGroupCategories {
    /**
     * 
     * @type {number}
     * @memberof NewMaterialGroupCategories
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface NewMaterialMaterialGroup
 */
export interface NewMaterialMaterialGroup {
    /**
     * 
     * @type {string}
     * @memberof NewMaterialMaterialGroup
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface NewMessageCount
 */
export interface NewMessageCount {
    /**
     * 
     * @type {Array<string>}
     * @memberof NewMessageCount
     */
    'conversationUuids': Array<string>;
}
/**
 * 
 * @export
 * @interface NewMessages
 */
export interface NewMessages {
    /**
     * 
     * @type {string}
     * @memberof NewMessages
     */
    'conversationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof NewMessages
     */
    'senderUuid': string;
    /**
     * 
     * @type {string}
     * @memberof NewMessages
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface NewNews
 */
export interface NewNews {
    /**
     * 
     * @type {string}
     * @memberof NewNews
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NewNews
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewNews
     */
    'userUuid'?: string;
}
/**
 * 
 * @export
 * @interface NewOrganization
 */
export interface NewOrganization {
    /**
     * 
     * @type {string}
     * @memberof NewOrganization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganization
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganization
     */
    'contractPeriod': string;
    /**
     * 
     * @type {number}
     * @memberof NewOrganization
     */
    'accountNumber': number;
    /**
     * 
     * @type {string}
     * @memberof NewOrganization
     */
    'itnavRepresentative': string;
}
/**
 * 
 * @export
 * @interface NewOrganizationAdmin
 */
export interface NewOrganizationAdmin {
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationAdmin
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationAdmin
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationAdmin
     */
    'confirmEmail': string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationAdmin
     */
    'organizationUuid': string;
}
/**
 * 
 * @export
 * @interface NewOrganizationUser
 */
export interface NewOrganizationUser {
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationUser
     */
    'confirmEmail': string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationUser
     */
    'organizationUuid': string;
    /**
     * 
     * @type {NewOrganizationUserDetail}
     * @memberof NewOrganizationUser
     */
    'detail': NewOrganizationUserDetail;
}
/**
 * 
 * @export
 * @interface NewOrganizationUserDetail
 */
export interface NewOrganizationUserDetail {
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationUserDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationUserDetail
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationUserDetail
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationUserDetail
     */
    'prefecture'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationUserDetail
     */
    'city'?: string;
}
/**
 * 
 * @export
 * @interface NewPreAdmin
 */
export interface NewPreAdmin {
    /**
     * 
     * @type {string}
     * @memberof NewPreAdmin
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof NewPreAdmin
     */
    'confirmEmail': string;
    /**
     * 
     * @type {string}
     * @memberof NewPreAdmin
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof NewPreAdmin
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface NewPreUser
 */
export interface NewPreUser {
    /**
     * 
     * @type {string}
     * @memberof NewPreUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof NewPreUser
     */
    'confirmEmail': string;
    /**
     * 
     * @type {string}
     * @memberof NewPreUser
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof NewPreUser
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface NewPreUserByAdmin
 */
export interface NewPreUserByAdmin {
    /**
     * 
     * @type {string}
     * @memberof NewPreUserByAdmin
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof NewPreUserByAdmin
     */
    'confirmEmail': string;
}
/**
 * 
 * @export
 * @interface NewSpecialUserByAdmin
 */
export interface NewSpecialUserByAdmin {
    /**
     * 
     * @type {string}
     * @memberof NewSpecialUserByAdmin
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NewSpecialUserByAdmin
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof NewSpecialUserByAdmin
     */
    'confirmEmail': string;
    /**
     * 
     * @type {NewUserDetail}
     * @memberof NewSpecialUserByAdmin
     */
    'detail': NewUserDetail;
}
/**
 * 
 * @export
 * @interface NewUser
 */
export interface NewUser {
    /**
     * 
     * @type {string}
     * @memberof NewUser
     */
    'ugcUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NewUser
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewUser
     */
    'confirmPassword'?: string;
    /**
     * 
     * @type {NewUserDetail}
     * @memberof NewUser
     */
    'detail': NewUserDetail;
}
/**
 * 
 * @export
 * @interface NewUserDetail
 */
export interface NewUserDetail {
    /**
     * 
     * @type {string}
     * @memberof NewUserDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewUserDetail
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof NewUserDetail
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof NewUserDetail
     */
    'prefecture': string;
    /**
     * 
     * @type {string}
     * @memberof NewUserDetail
     */
    'city': string;
}
/**
 * 
 * @export
 * @interface News
 */
export interface News {
    /**
     * 
     * @type {string}
     * @memberof News
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    'userUuid': string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    'updatedAt': string;
    /**
     * 
     * @type {UGC}
     * @memberof News
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'contractPeriod': string;
    /**
     * 
     * @type {number}
     * @memberof Organization
     */
    'accountNumber': number;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'organizationRepresentative': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'itnavRepresentative': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof Organization
     */
    'deleted': boolean;
    /**
     * 
     * @type {Array<OrganizationAdmin>}
     * @memberof Organization
     */
    'organizationAdmins'?: Array<OrganizationAdmin>;
    /**
     * 
     * @type {Array<OrganizationUser>}
     * @memberof Organization
     */
    'organizationUsers'?: Array<OrganizationUser>;
}
/**
 * 
 * @export
 * @interface OrganizationAdmin
 */
export interface OrganizationAdmin {
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'userDetailUuid': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'cusId': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdmin
     */
    'roleId': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'organizationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'lastLoginAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdmin
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationAdmin
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationAdmin
     */
    'registered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationAdmin
     */
    'paidFlag': boolean;
    /**
     * 
     * @type {UserDetail}
     * @memberof OrganizationAdmin
     */
    'userDetail': UserDetail;
    /**
     * 
     * @type {Role}
     * @memberof OrganizationAdmin
     */
    'role': Role;
    /**
     * 
     * @type {UGC}
     * @memberof OrganizationAdmin
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface OrganizationUser
 */
export interface OrganizationUser {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'userDetailUuid': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'cusId': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationUser
     */
    'roleId': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'organizationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'lastLoginAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUser
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUser
     */
    'registered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUser
     */
    'paidFlag': boolean;
    /**
     * 
     * @type {UserDetail}
     * @memberof OrganizationUser
     */
    'userDetail': UserDetail;
    /**
     * 
     * @type {Role}
     * @memberof OrganizationUser
     */
    'role': Role;
    /**
     * 
     * @type {UGC}
     * @memberof OrganizationUser
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface PaginatedAdminList
 */
export interface PaginatedAdminList {
    /**
     * 
     * @type {Array<Admin>}
     * @memberof PaginatedAdminList
     */
    'items': Array<Admin>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedAdminList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedCompleteMaterialGroupList
 */
export interface PaginatedCompleteMaterialGroupList {
    /**
     * 
     * @type {Array<CompleteMaterialGroup>}
     * @memberof PaginatedCompleteMaterialGroupList
     */
    'items': Array<CompleteMaterialGroup>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedCompleteMaterialGroupList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedCompleteMaterialList
 */
export interface PaginatedCompleteMaterialList {
    /**
     * 
     * @type {Array<CompleteMaterial>}
     * @memberof PaginatedCompleteMaterialList
     */
    'items': Array<CompleteMaterial>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedCompleteMaterialList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedConversation
 */
export interface PaginatedConversation {
    /**
     * 
     * @type {Array<Conversation>}
     * @memberof PaginatedConversation
     */
    'items': Array<Conversation>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedConversation
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedConversationByAdmin
 */
export interface PaginatedConversationByAdmin {
    /**
     * 
     * @type {Array<ConversationByAdmin>}
     * @memberof PaginatedConversationByAdmin
     */
    'items': Array<ConversationByAdmin>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedConversationByAdmin
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedConversationByOrganizationAdmin
 */
export interface PaginatedConversationByOrganizationAdmin {
    /**
     * 
     * @type {Array<ConversationByOrganizationAdmin>}
     * @memberof PaginatedConversationByOrganizationAdmin
     */
    'items': Array<ConversationByOrganizationAdmin>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedConversationByOrganizationAdmin
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedMaterialGroupList
 */
export interface PaginatedMaterialGroupList {
    /**
     * 
     * @type {Array<MaterialGroupList>}
     * @memberof PaginatedMaterialGroupList
     */
    'items': Array<MaterialGroupList>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMaterialGroupList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedMaterialList
 */
export interface PaginatedMaterialList {
    /**
     * 
     * @type {Array<Material>}
     * @memberof PaginatedMaterialList
     */
    'items': Array<Material>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMaterialList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedNewsList
 */
export interface PaginatedNewsList {
    /**
     * 
     * @type {Array<News>}
     * @memberof PaginatedNewsList
     */
    'items': Array<News>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedNewsList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedOrganizationAdminList
 */
export interface PaginatedOrganizationAdminList {
    /**
     * 
     * @type {Array<OrganizationAdmin>}
     * @memberof PaginatedOrganizationAdminList
     */
    'items': Array<OrganizationAdmin>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrganizationAdminList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedOrganizationList
 */
export interface PaginatedOrganizationList {
    /**
     * 
     * @type {Array<Organization>}
     * @memberof PaginatedOrganizationList
     */
    'items': Array<Organization>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrganizationList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedOrganizationUserList
 */
export interface PaginatedOrganizationUserList {
    /**
     * 
     * @type {Array<OrganizationUser>}
     * @memberof PaginatedOrganizationUserList
     */
    'items': Array<OrganizationUser>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrganizationUserList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedUGCList
 */
export interface PaginatedUGCList {
    /**
     * 
     * @type {Array<UGC>}
     * @memberof PaginatedUGCList
     */
    'items': Array<UGC>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedUGCList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaginatedUserList
 */
export interface PaginatedUserList {
    /**
     * 
     * @type {Array<User>}
     * @memberof PaginatedUserList
     */
    'items': Array<User>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedUserList
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PatchBookmarkByUuid
 */
export interface PatchBookmarkByUuid {
    /**
     * 
     * @type {object}
     * @memberof PatchBookmarkByUuid
     */
    'bookmark': object;
}
/**
 * 
 * @export
 * @interface PatchReadFlag
 */
export interface PatchReadFlag {
    /**
     * 
     * @type {number}
     * @memberof PatchReadFlag
     */
    'affected': number;
}
/**
 * 
 * @export
 * @interface Payment
 */
export interface Payment {
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'object': string;
    /**
     * 
     * @type {object}
     * @memberof Payment
     */
    'billing_details': object;
    /**
     * 
     * @type {PaymentCard}
     * @memberof Payment
     */
    'card': PaymentCard;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    'created': number;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'customer': string;
    /**
     * 
     * @type {boolean}
     * @memberof Payment
     */
    'livemode': boolean;
    /**
     * 
     * @type {object}
     * @memberof Payment
     */
    'metadata': object;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface PaymentCard
 */
export interface PaymentCard {
    /**
     * 
     * @type {string}
     * @memberof PaymentCard
     */
    'brand': string;
    /**
     * 
     * @type {object}
     * @memberof PaymentCard
     */
    'checks': object;
    /**
     * 
     * @type {string}
     * @memberof PaymentCard
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentCard
     */
    'exp_month': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentCard
     */
    'exp_year': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentCard
     */
    'fingerprint': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentCard
     */
    'funding': string;
    /**
     * 
     * @type {object}
     * @memberof PaymentCard
     */
    'generated_from'?: object;
    /**
     * 
     * @type {number}
     * @memberof PaymentCard
     */
    'last4': number;
    /**
     * 
     * @type {object}
     * @memberof PaymentCard
     */
    'networks': object;
    /**
     * 
     * @type {object}
     * @memberof PaymentCard
     */
    'three_d_secure_usage': object;
    /**
     * 
     * @type {object}
     * @memberof PaymentCard
     */
    'wallet'?: object;
}
/**
 * 
 * @export
 * @interface Plan
 */
export interface Plan {
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'object': string;
    /**
     * 
     * @type {boolean}
     * @memberof Plan
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'aggregate_usage': string;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'amount_decimal': string;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'billing_scheme': string;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    'created': number;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'interval': string;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    'interval_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof Plan
     */
    'livemode': boolean;
    /**
     * 
     * @type {object}
     * @memberof Plan
     */
    'metadata': object;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'nickname': string;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'product': string;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'tiers_mode': string;
    /**
     * 
     * @type {object}
     * @memberof Plan
     */
    'transform_usage': object;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'trial_period_days': string;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'usage_type': string;
}
/**
 * 
 * @export
 * @interface PostCompleteMaterial
 */
export interface PostCompleteMaterial {
    /**
     * 
     * @type {string}
     * @memberof PostCompleteMaterial
     */
    'completeMaterialUuid': string;
}
/**
 * 
 * @export
 * @interface PostCompleteMaterialGroup
 */
export interface PostCompleteMaterialGroup {
    /**
     * 
     * @type {string}
     * @memberof PostCompleteMaterialGroup
     */
    'completeMaterialGroupUuid': string;
}
/**
 * 
 * @export
 * @interface PreAdmin
 */
export interface PreAdmin {
    /**
     * 
     * @type {string}
     * @memberof PreAdmin
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PreAdmin
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PreAdmin
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PreAdmin
     */
    'userDetailUuid': string;
    /**
     * 
     * @type {number}
     * @memberof PreAdmin
     */
    'roleId': number;
    /**
     * 
     * @type {string}
     * @memberof PreAdmin
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof PreAdmin
     */
    'lastLoginAt': string;
    /**
     * 
     * @type {string}
     * @memberof PreAdmin
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PreAdmin
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof PreAdmin
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreAdmin
     */
    'registered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreAdmin
     */
    'paidFlag': boolean;
    /**
     * 
     * @type {Role}
     * @memberof PreAdmin
     */
    'role': Role;
    /**
     * 
     * @type {UGC}
     * @memberof PreAdmin
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface PreUser
 */
export interface PreUser {
    /**
     * 
     * @type {string}
     * @memberof PreUser
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PreUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PreUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PreUser
     */
    'userDetailUuid': string;
    /**
     * 
     * @type {number}
     * @memberof PreUser
     */
    'roleId': number;
    /**
     * 
     * @type {string}
     * @memberof PreUser
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof PreUser
     */
    'lastLoginAt': string;
    /**
     * 
     * @type {string}
     * @memberof PreUser
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PreUser
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof PreUser
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreUser
     */
    'registered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreUser
     */
    'paidFlag': boolean;
    /**
     * 
     * @type {Role}
     * @memberof PreUser
     */
    'role': Role;
    /**
     * 
     * @type {UGC}
     * @memberof PreUser
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface Price
 */
export interface Price {
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'object': string;
    /**
     * 
     * @type {boolean}
     * @memberof Price
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'billing_scheme': string;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    'created': number;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'currency': string;
    /**
     * 
     * @type {boolean}
     * @memberof Price
     */
    'livemode': boolean;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'lookup_key': string;
    /**
     * 
     * @type {object}
     * @memberof Price
     */
    'metadata': object;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'nickname': string;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'product': string;
    /**
     * 
     * @type {PriceRecurring}
     * @memberof Price
     */
    'recurring': PriceRecurring;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'tax_behavior': string;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'tiers_mode': string;
    /**
     * 
     * @type {object}
     * @memberof Price
     */
    'transform_quantity': object;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    'unit_amount': number;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'unit_amount_decimal': string;
}
/**
 * 
 * @export
 * @interface PriceRecurring
 */
export interface PriceRecurring {
    /**
     * 
     * @type {string}
     * @memberof PriceRecurring
     */
    'aggregate_usage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PriceRecurring
     */
    'interval'?: string;
    /**
     * 
     * @type {number}
     * @memberof PriceRecurring
     */
    'interval_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceRecurring
     */
    'usage_type'?: string;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'object': string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'active': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'attributes': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'created': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'images': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'livemode': boolean;
    /**
     * 
     * @type {object}
     * @memberof Product
     */
    'metadata': object;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'name': string;
    /**
     * 
     * @type {object}
     * @memberof Product
     */
    'package_dimensions': object;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'shippable': boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'statement_descriptor': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'tax_code': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'unit_label': string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'updated': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface Promo
 */
export interface Promo {
    /**
     * 
     * @type {string}
     * @memberof Promo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Promo
     */
    'object'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Promo
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Promo
     */
    'code'?: string;
    /**
     * 
     * @type {Coupon}
     * @memberof Promo
     */
    'coupon'?: Coupon;
    /**
     * 
     * @type {number}
     * @memberof Promo
     */
    'created'?: number;
    /**
     * 
     * @type {string}
     * @memberof Promo
     */
    'customer'?: string;
    /**
     * 
     * @type {number}
     * @memberof Promo
     */
    'expires_at'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Promo
     */
    'livemode'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Promo
     */
    'max_redemptions'?: number;
    /**
     * 
     * @type {object}
     * @memberof Promo
     */
    'metadata'?: object;
    /**
     * 
     * @type {PromoRestrictions}
     * @memberof Promo
     */
    'restrictions'?: PromoRestrictions;
    /**
     * 
     * @type {number}
     * @memberof Promo
     */
    'times_redeemed'?: number;
}
/**
 * 
 * @export
 * @interface PromoRestrictions
 */
export interface PromoRestrictions {
    /**
     * 
     * @type {boolean}
     * @memberof PromoRestrictions
     */
    'first_time_transaction'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PromoRestrictions
     */
    'minimum_amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoRestrictions
     */
    'minimum_amount_currency'?: string;
}
/**
 * 
 * @export
 * @interface ResetPasswordBody
 */
export interface ResetPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBody
     */
    'confirmEmail': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordResponse
 */
export interface ResetPasswordResponse {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordResponse
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordResponse
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SetPasswordBody
 */
export interface SetPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordBody
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum SortDirection {
    Asc = 'ASC',
    Desc = 'DESC'
}

/**
 * 
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'object': string;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'application_fee_percent': number;
    /**
     * 
     * @type {object}
     * @memberof Subscription
     */
    'automatic_tax': object;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'billing_cycle_anchor': number;
    /**
     * 
     * @type {object}
     * @memberof Subscription
     */
    'billing_thresholds': object;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'cancel_at': number;
    /**
     * 
     * @type {boolean}
     * @memberof Subscription
     */
    'cancel_at_period_end': boolean;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'canceled_at': number;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'collection_method': string;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'created': number;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'current_period_end': number;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'current_period_start': number;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'customer': string;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'days_until_due': number;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'default_payment_method': string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'default_source': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof Subscription
     */
    'default_tax_rates': Array<object>;
    /**
     * 
     * @type {Discount}
     * @memberof Subscription
     */
    'discount': Discount;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'ended_at': number;
    /**
     * 
     * @type {SubscriptionItems}
     * @memberof Subscription
     */
    'items': SubscriptionItems;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'latest_invoice': string;
    /**
     * 
     * @type {boolean}
     * @memberof Subscription
     */
    'livemode': boolean;
    /**
     * 
     * @type {object}
     * @memberof Subscription
     */
    'metadata': object;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'next_pending_invoice_item_invoice': number;
    /**
     * 
     * @type {object}
     * @memberof Subscription
     */
    'pause_collection': object;
    /**
     * 
     * @type {object}
     * @memberof Subscription
     */
    'payment_setting': object;
    /**
     * 
     * @type {object}
     * @memberof Subscription
     */
    'pending_invoice_item_interval': object;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'pending_setup_intent': string;
    /**
     * 
     * @type {object}
     * @memberof Subscription
     */
    'pending_update': object;
    /**
     * 
     * @type {Plan}
     * @memberof Subscription
     */
    'plan': Plan;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'schedule': string;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'start_date': number;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'test_clock': string;
    /**
     * 
     * @type {object}
     * @memberof Subscription
     */
    'transfer_data': object;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'trial_end': number;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'trial_start': number;
}
/**
 * 
 * @export
 * @interface SubscriptionItems
 */
export interface SubscriptionItems {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionItems
     */
    'object'?: string;
    /**
     * 
     * @type {Array<SubscriptionItemsData>}
     * @memberof SubscriptionItems
     */
    'data'?: Array<SubscriptionItemsData>;
}
/**
 * 
 * @export
 * @interface SubscriptionItemsData
 */
export interface SubscriptionItemsData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionItemsData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionItemsData
     */
    'object'?: string;
    /**
     * 
     * @type {object}
     * @memberof SubscriptionItemsData
     */
    'billing_thresholds'?: object;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionItemsData
     */
    'created'?: number;
    /**
     * 
     * @type {object}
     * @memberof SubscriptionItemsData
     */
    'metadata'?: object;
    /**
     * 
     * @type {Plan}
     * @memberof SubscriptionItemsData
     */
    'plan'?: Plan;
    /**
     * 
     * @type {Price}
     * @memberof SubscriptionItemsData
     */
    'price'?: Price;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionItemsData
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionItemsData
     */
    'subscription'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof SubscriptionItemsData
     */
    'tax_rates'?: Array<object>;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'token': string;
}
/**
 * アップロードされた物
 * @export
 * @interface UGC
 */
export interface UGC {
    /**
     * 
     * @type {boolean}
     * @memberof UGC
     */
    'deleted': boolean;
    /**
     * 
     * @type {UGCType}
     * @memberof UGC
     */
    'ugcType': UGCType;
    /**
     * 
     * @type {string}
     * @memberof UGC
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof UGC
     */
    'thumbnailUrl': string;
    /**
     * 
     * @type {MulterFileInfo}
     * @memberof UGC
     */
    'metadata': MulterFileInfo;
    /**
     * 
     * @type {string}
     * @memberof UGC
     */
    'hashSHA256': string;
    /**
     * 
     * @type {string}
     * @memberof UGC
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof UGC
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UGC
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum UGCType {
    Pdf = 'pdf',
    Image = 'image',
    Zip = 'zip',
}

/**
 * 
 * @export
 * @interface UpdateAdmin
 */
export interface UpdateAdmin {
    /**
     * 
     * @type {string}
     * @memberof UpdateAdmin
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdmin
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdmin
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdmin
     */
    'ugcUuid'?: string;
}
/**
 * 
 * @export
 * @interface UpdateCard
 */
export interface UpdateCard {
    /**
     * 
     * @type {string}
     * @memberof UpdateCard
     */
    'cusId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCard
     */
    'cardId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCard
     */
    'exp_month'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCard
     */
    'exp_year'?: number;
}
/**
 * 
 * @export
 * @interface UpdateCategory
 */
export interface UpdateCategory {
    /**
     * 
     * @type {string}
     * @memberof UpdateCategory
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCategory
     */
    'parentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCategory
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCategory
     */
    'ugcUuid'?: string;
}
/**
 * 
 * @export
 * @interface UpdateCustomer
 */
export interface UpdateCustomer {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomer
     */
    'cusId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomer
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomer
     */
    'email'?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateCustomer
     */
    'metadata'?: object;
}
/**
 * 
 * @export
 * @interface UpdateMaterial
 */
export interface UpdateMaterial {
    /**
     * 
     * @type {Array<NewMaterialMaterialGroup>}
     * @memberof UpdateMaterial
     */
    'materialGroup'?: Array<NewMaterialMaterialGroup>;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaterial
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaterial
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaterial
     */
    'ugcUuid'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMaterialGroup
 */
export interface UpdateMaterialGroup {
    /**
     * 
     * @type {string}
     * @memberof UpdateMaterialGroup
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaterialGroup
     */
    'ugcUuid'?: string;
    /**
     * 
     * @type {Array<UpdateMaterialGroupMaterials>}
     * @memberof UpdateMaterialGroup
     */
    'materials'?: Array<UpdateMaterialGroupMaterials>;
    /**
     * 
     * @type {Array<NewMaterialGroupCategories>}
     * @memberof UpdateMaterialGroup
     */
    'categories'?: Array<NewMaterialGroupCategories>;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaterialGroup
     */
    'planId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMaterialGroup
     */
    'visibilityFlag'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateMaterialGroupMaterials
 */
export interface UpdateMaterialGroupMaterials {
    /**
     * 
     * @type {string}
     * @memberof UpdateMaterialGroupMaterials
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMaterialGroupSort
 */
export interface UpdateMaterialGroupSort {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMaterialGroupSort
     */
    'direction': boolean;
}
/**
 * 
 * @export
 * @interface UpdateMaterialSort
 */
export interface UpdateMaterialSort {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMaterialSort
     */
    'direction': boolean;
}
/**
 * 
 * @export
 * @interface UpdateNews
 */
export interface UpdateNews {
    /**
     * 
     * @type {string}
     * @memberof UpdateNews
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNews
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNews
     */
    'userUuid'?: string;
}
/**
 * 
 * @export
 * @interface UpdateOrganization
 */
export interface UpdateOrganization {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization
     */
    'contractPeriod'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrganization
     */
    'accountNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization
     */
    'organizationRepresentative'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization
     */
    'itnavRepresentative'?: string;
}
/**
 * 
 * @export
 * @interface UpdateOrganizationAdmin
 */
export interface UpdateOrganizationAdmin {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationAdmin
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationAdmin
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationAdmin
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationAdmin
     */
    'organizationUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationAdmin
     */
    'ugcUuid'?: string;
}
/**
 * 
 * @export
 * @interface UpdateOrganizationUser
 */
export interface UpdateOrganizationUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationUser
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationUser
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationUser
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationUser
     */
    'ugcUuid'?: string;
    /**
     * 
     * @type {UserDetail}
     * @memberof UpdateOrganizationUser
     */
    'detail'?: UserDetail;
}
/**
 * 
 * @export
 * @interface UpdateSubscription
 */
export interface UpdateSubscription {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscription
     */
    'subId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSubscription
     */
    'endOfPeriodCancel'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateSubscription
     */
    'trialEndDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscription
     */
    'trialEndNow'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscription
     */
    'couId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscription
     */
    'promoCode'?: string;
}
/**
 * 
 * @export
 * @interface UpdateUser
 */
export interface UpdateUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateUser
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUser
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUser
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUser
     */
    'ugcUuid'?: string;
    /**
     * 
     * @type {UpdateUserDetail}
     * @memberof UpdateUser
     */
    'detail'?: UpdateUserDetail;
}
/**
 * 
 * @export
 * @interface UpdateUserDetail
 */
export interface UpdateUserDetail {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDetail
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDetail
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDetail
     */
    'prefecture'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDetail
     */
    'city'?: string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'userDetailUuid': string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'roleId': number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'ugcUuid': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastLoginAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'registered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'paidFlag': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'cusId': string;
    /**
     * 
     * @type {UserDetail}
     * @memberof User
     */
    'userDetail': UserDetail;
    /**
     * 
     * @type {Role}
     * @memberof User
     */
    'role': Role;
    /**
     * 
     * @type {UGC}
     * @memberof User
     */
    'ugc': UGC;
}
/**
 * 
 * @export
 * @interface UserDetail
 */
export interface UserDetail {
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'prefecture'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {Material}
     * @memberof UserDetail
     */
    'bookmark'?: Material;
    /**
     * 
     * @type {CompleteMaterialGroup}
     * @memberof UserDetail
     */
    'userDetailMaterialGroups'?: CompleteMaterialGroup;
    /**
     * 
     * @type {CompleteMaterial}
     * @memberof UserDetail
     */
    'userDetailMaterials'?: CompleteMaterial;
}

/**
 * AdminsApi - axios parameter creator
 * @export
 */
export const AdminsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create pre admin
         * @param {NewPreAdmin} newPreAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreAdmin: async (newPreAdmin: NewPreAdmin, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newPreAdmin' is not null or undefined
            assertParamExists('createPreAdmin', 'newPreAdmin', newPreAdmin)
            const localVarPath = `/admin/pre`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newPreAdmin, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteAdminByUuid', 'uuid', uuid)
            const localVarPath = `/admin/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getAdminByUuid', 'uuid', uuid)
            const localVarPath = `/admin/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admins
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins: async (limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send admin registration token
         * @param {EmailWithConfirm} emailWithConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdminRegisterToken: async (emailWithConfirm: EmailWithConfirm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailWithConfirm' is not null or undefined
            assertParamExists('sendAdminRegisterToken', 'emailWithConfirm', emailWithConfirm)
            const localVarPath = `/admin/pre/send-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailWithConfirm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update admin by uuid
         * @param {string} uuid 
         * @param {UpdateAdmin} updateAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminByUuid: async (uuid: string, updateAdmin: UpdateAdmin, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateAdminByUuid', 'uuid', uuid)
            // verify required parameter 'updateAdmin' is not null or undefined
            assertParamExists('updateAdminByUuid', 'updateAdmin', updateAdmin)
            const localVarPath = `/admin/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdmin, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminsApi - functional programming interface
 * @export
 */
export const AdminsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdmin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdmin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create pre admin
         * @param {NewPreAdmin} newPreAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPreAdmin(newPreAdmin: NewPreAdmin, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPreAdminAndToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPreAdmin(newPreAdmin, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get admins
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdmins(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedAdminList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdmins(limit, offset, direction, column, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary send admin registration token
         * @param {EmailWithConfirm} emailWithConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAdminRegisterToken(emailWithConfirm: EmailWithConfirm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAdminRegisterToken(emailWithConfirm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update admin by uuid
         * @param {string} uuid 
         * @param {UpdateAdmin} updateAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminByUuid(uuid: string, updateAdmin: UpdateAdmin, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminByUuid(uuid, updateAdmin, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminsApi - factory interface
 * @export
 */
export const AdminsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmin(options?: any): AxiosPromise<EnvelopedAdmin> {
            return localVarFp.createAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create pre admin
         * @param {NewPreAdmin} newPreAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreAdmin(newPreAdmin: NewPreAdmin, options?: any): AxiosPromise<EnvelopedPreAdminAndToken> {
            return localVarFp.createPreAdmin(newPreAdmin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminByUuid(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAdminByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminByUuid(uuid: string, options?: any): AxiosPromise<EnvelopedAdmin> {
            return localVarFp.getAdminByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admins
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: any): AxiosPromise<EnvelopedPaginatedAdminList> {
            return localVarFp.getAdmins(limit, offset, direction, column, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send admin registration token
         * @param {EmailWithConfirm} emailWithConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdminRegisterToken(emailWithConfirm: EmailWithConfirm, options?: any): AxiosPromise<EnvelopedToken> {
            return localVarFp.sendAdminRegisterToken(emailWithConfirm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update admin by uuid
         * @param {string} uuid 
         * @param {UpdateAdmin} updateAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminByUuid(uuid: string, updateAdmin: UpdateAdmin, options?: any): AxiosPromise<EnvelopedAdmin> {
            return localVarFp.updateAdminByUuid(uuid, updateAdmin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminsApi - object-oriented interface
 * @export
 * @class AdminsApi
 * @extends {BaseAPI}
 */
export class AdminsApi extends BaseAPI {
    /**
     * 
     * @summary Create admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public createAdmin(options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).createAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create pre admin
     * @param {NewPreAdmin} newPreAdmin 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public createPreAdmin(newPreAdmin: NewPreAdmin, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).createPreAdmin(newPreAdmin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete admin by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public deleteAdminByUuid(uuid: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).deleteAdminByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admin by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public getAdminByUuid(uuid: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).getAdminByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admins
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public getAdmins(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).getAdmins(limit, offset, direction, column, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send admin registration token
     * @param {EmailWithConfirm} emailWithConfirm 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public sendAdminRegisterToken(emailWithConfirm: EmailWithConfirm, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).sendAdminRegisterToken(emailWithConfirm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update admin by uuid
     * @param {string} uuid 
     * @param {UpdateAdmin} updateAdmin 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public updateAdminByUuid(uuid: string, updateAdmin: UpdateAdmin, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).updateAdminByUuid(uuid, updateAdmin, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogin: async (loginBody: LoginBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginBody' is not null or undefined
            assertParamExists('adminLogin', 'loginBody', loginBody)
            const localVarPath = `/auth/admin/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminLogin: async (loginBody: LoginBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginBody' is not null or undefined
            assertParamExists('organizationAdminLogin', 'loginBody', loginBody)
            const localVarPath = `/auth/organization-admin/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationUserLogin: async (loginBody: LoginBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginBody' is not null or undefined
            assertParamExists('organizationUserLogin', 'loginBody', loginBody)
            const localVarPath = `/auth/organization-user/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAdminPassword: async (resetPasswordBody: ResetPasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordBody' is not null or undefined
            assertParamExists('resetAdminPassword', 'resetPasswordBody', resetPasswordBody)
            const localVarPath = `/auth/admin/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOrganizationAdminPassword: async (resetPasswordBody: ResetPasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordBody' is not null or undefined
            assertParamExists('resetOrganizationAdminPassword', 'resetPasswordBody', resetPasswordBody)
            const localVarPath = `/auth/organization-admin/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOrganizationUserPassword: async (resetPasswordBody: ResetPasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordBody' is not null or undefined
            assertParamExists('resetOrganizationUserPassword', 'resetPasswordBody', resetPasswordBody)
            const localVarPath = `/auth/organization-user/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (resetPasswordBody: ResetPasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordBody' is not null or undefined
            assertParamExists('resetUserPassword', 'resetPasswordBody', resetPasswordBody)
            const localVarPath = `/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdminPassword: async (setPasswordBody: SetPasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setPasswordBody' is not null or undefined
            assertParamExists('setAdminPassword', 'setPasswordBody', setPasswordBody)
            const localVarPath = `/auth/admin/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationAdminPassword: async (setPasswordBody: SetPasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setPasswordBody' is not null or undefined
            assertParamExists('setOrganizationAdminPassword', 'setPasswordBody', setPasswordBody)
            const localVarPath = `/auth/organization-admin/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationUserPassword: async (setPasswordBody: SetPasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setPasswordBody' is not null or undefined
            assertParamExists('setOrganizationUserPassword', 'setPasswordBody', setPasswordBody)
            const localVarPath = `/auth/organization-user/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPassword: async (setPasswordBody: SetPasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setPasswordBody' is not null or undefined
            assertParamExists('setUserPassword', 'setPasswordBody', setPasswordBody)
            const localVarPath = `/auth/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogin: async (loginBody: LoginBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginBody' is not null or undefined
            assertParamExists('userLogin', 'loginBody', loginBody)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLogin(loginBody: LoginBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedAdminAndToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLogin(loginBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAdminLogin(loginBody: LoginBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganizationAdminAndToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAdminLogin(loginBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary User login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationUserLogin(loginBody: LoginBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganizationUserAndToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationUserLogin(loginBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetAdminPassword(resetPasswordBody: ResetPasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedResetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetAdminPassword(resetPasswordBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetOrganizationAdminPassword(resetPasswordBody: ResetPasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedResetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetOrganizationAdminPassword(resetPasswordBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetOrganizationUserPassword(resetPasswordBody: ResetPasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedResetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetOrganizationUserPassword(resetPasswordBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(resetPasswordBody: ResetPasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedResetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(resetPasswordBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAdminPassword(setPasswordBody: SetPasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedSetPasswordResponseByAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAdminPassword(setPasswordBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOrganizationAdminPassword(setPasswordBody: SetPasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedSetPasswordResponseByOrganizationAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOrganizationAdminPassword(setPasswordBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOrganizationUserPassword(setPasswordBody: SetPasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedSetPasswordResponseByOrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOrganizationUserPassword(setPasswordBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserPassword(setPasswordBody: SetPasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedSetPasswordResponseByUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserPassword(setPasswordBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary User login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLogin(loginBody: LoginBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedUserAndToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLogin(loginBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogin(loginBody: LoginBody, options?: any): AxiosPromise<EnvelopedAdminAndToken> {
            return localVarFp.adminLogin(loginBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options?: any): AxiosPromise<EnvelopedUser> {
            return localVarFp.getMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminLogin(loginBody: LoginBody, options?: any): AxiosPromise<EnvelopedOrganizationAdminAndToken> {
            return localVarFp.organizationAdminLogin(loginBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationUserLogin(loginBody: LoginBody, options?: any): AxiosPromise<EnvelopedOrganizationUserAndToken> {
            return localVarFp.organizationUserLogin(loginBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAdminPassword(resetPasswordBody: ResetPasswordBody, options?: any): AxiosPromise<EnvelopedResetPasswordResponse> {
            return localVarFp.resetAdminPassword(resetPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOrganizationAdminPassword(resetPasswordBody: ResetPasswordBody, options?: any): AxiosPromise<EnvelopedResetPasswordResponse> {
            return localVarFp.resetOrganizationAdminPassword(resetPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOrganizationUserPassword(resetPasswordBody: ResetPasswordBody, options?: any): AxiosPromise<EnvelopedResetPasswordResponse> {
            return localVarFp.resetOrganizationUserPassword(resetPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset user password
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(resetPasswordBody: ResetPasswordBody, options?: any): AxiosPromise<EnvelopedResetPasswordResponse> {
            return localVarFp.resetUserPassword(resetPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdminPassword(setPasswordBody: SetPasswordBody, options?: any): AxiosPromise<EnvelopedSetPasswordResponseByAdmin> {
            return localVarFp.setAdminPassword(setPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationAdminPassword(setPasswordBody: SetPasswordBody, options?: any): AxiosPromise<EnvelopedSetPasswordResponseByOrganizationAdmin> {
            return localVarFp.setOrganizationAdminPassword(setPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationUserPassword(setPasswordBody: SetPasswordBody, options?: any): AxiosPromise<EnvelopedSetPasswordResponseByOrganizationUser> {
            return localVarFp.setOrganizationUserPassword(setPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set user password
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPassword(setPasswordBody: SetPasswordBody, options?: any): AxiosPromise<EnvelopedSetPasswordResponseByUser> {
            return localVarFp.setUserPassword(setPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User login
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogin(loginBody: LoginBody, options?: any): AxiosPromise<EnvelopedUserAndToken> {
            return localVarFp.userLogin(loginBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Admin login
     * @param {LoginBody} loginBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public adminLogin(loginBody: LoginBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).adminLogin(loginBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getMe(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).getMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin login
     * @param {LoginBody} loginBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public organizationAdminLogin(loginBody: LoginBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).organizationAdminLogin(loginBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User login
     * @param {LoginBody} loginBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public organizationUserLogin(loginBody: LoginBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).organizationUserLogin(loginBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset user password
     * @param {ResetPasswordBody} resetPasswordBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetAdminPassword(resetPasswordBody: ResetPasswordBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetAdminPassword(resetPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset user password
     * @param {ResetPasswordBody} resetPasswordBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetOrganizationAdminPassword(resetPasswordBody: ResetPasswordBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetOrganizationAdminPassword(resetPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset user password
     * @param {ResetPasswordBody} resetPasswordBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetOrganizationUserPassword(resetPasswordBody: ResetPasswordBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetOrganizationUserPassword(resetPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset user password
     * @param {ResetPasswordBody} resetPasswordBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetUserPassword(resetPasswordBody: ResetPasswordBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetUserPassword(resetPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set user password
     * @param {SetPasswordBody} setPasswordBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public setAdminPassword(setPasswordBody: SetPasswordBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).setAdminPassword(setPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set user password
     * @param {SetPasswordBody} setPasswordBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public setOrganizationAdminPassword(setPasswordBody: SetPasswordBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).setOrganizationAdminPassword(setPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set user password
     * @param {SetPasswordBody} setPasswordBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public setOrganizationUserPassword(setPasswordBody: SetPasswordBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).setOrganizationUserPassword(setPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set user password
     * @param {SetPasswordBody} setPasswordBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public setUserPassword(setPasswordBody: SetPasswordBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).setUserPassword(setPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User login
     * @param {LoginBody} loginBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public userLogin(loginBody: LoginBody, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).userLogin(loginBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create category
         * @param {NewCategory} [newCategory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory: async (newCategory?: NewCategory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newCategory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete category by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCategoryById', 'id', id)
            const localVarPath = `/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get categories
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get category by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryById', 'id', id)
            const localVarPath = `/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update category by id
         * @param {number} id 
         * @param {UpdateCategory} updateCategory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryById: async (id: number, updateCategory: UpdateCategory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCategoryById', 'id', id)
            // verify required parameter 'updateCategory' is not null or undefined
            assertParamExists('updateCategoryById', 'updateCategory', updateCategory)
            const localVarPath = `/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCategory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create category
         * @param {NewCategory} [newCategory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategory(newCategory?: NewCategory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(newCategory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete category by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategoryById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategoryById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get categories
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedCategoryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(limit, offset, direction, column, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get category by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update category by id
         * @param {number} id 
         * @param {UpdateCategory} updateCategory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategoryById(id: number, updateCategory: UpdateCategory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategoryById(id, updateCategory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create category
         * @param {NewCategory} [newCategory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory(newCategory?: NewCategory, options?: any): AxiosPromise<EnvelopedCategory> {
            return localVarFp.createCategory(newCategory, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete category by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryById(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCategoryById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get categories
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: any): AxiosPromise<EnvelopedCategoryList> {
            return localVarFp.getCategories(limit, offset, direction, column, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get category by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById(id: number, options?: any): AxiosPromise<EnvelopedCategory> {
            return localVarFp.getCategoryById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update category by id
         * @param {number} id 
         * @param {UpdateCategory} updateCategory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryById(id: number, updateCategory: UpdateCategory, options?: any): AxiosPromise<EnvelopedCategory> {
            return localVarFp.updateCategoryById(id, updateCategory, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Create category
     * @param {NewCategory} [newCategory] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public createCategory(newCategory?: NewCategory, options?: AxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).createCategory(newCategory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete category by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public deleteCategoryById(id: number, options?: AxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).deleteCategoryById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get categories
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getCategories(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).getCategories(limit, offset, direction, column, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get category by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getCategoryById(id: number, options?: AxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).getCategoryById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update category by id
     * @param {number} id 
     * @param {UpdateCategory} updateCategory 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public updateCategoryById(id: number, updateCategory: UpdateCategory, options?: AxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).updateCategoryById(id, updateCategory, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary send Contacts
         * @param {Contacts} [contacts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContacts: async (contacts?: Contacts, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contacts, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary send Contacts
         * @param {Contacts} [contacts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendContacts(contacts?: Contacts, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendContacts(contacts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactsApiFp(configuration)
    return {
        /**
         * 
         * @summary send Contacts
         * @param {Contacts} [contacts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContacts(contacts?: Contacts, options?: any): AxiosPromise<void> {
            return localVarFp.sendContacts(contacts, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     * 
     * @summary send Contacts
     * @param {Contacts} [contacts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public sendContacts(contacts?: Contacts, options?: AxiosRequestConfig) {
        return ContactsApiFp(this.configuration).sendContacts(contacts, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConversationsApi - axios parameter creator
 * @export
 */
export const ConversationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create conversations
         * @param {NewConversations} newConversations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversations: async (newConversations: NewConversations, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newConversations' is not null or undefined
            assertParamExists('createConversations', 'newConversations', newConversations)
            const localVarPath = `/conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newConversations, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get conversations
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getConversation', 'uuid', uuid)
            const localVarPath = `/conversation/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get conversations by admin uuid
         * @param {string} uuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationByAdminUuid: async (uuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getConversationByAdminUuid', 'uuid', uuid)
            const localVarPath = `/conversation/admin/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get conversations by organization admin uuid
         * @param {string} organizationUuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationByOrganizationAdminUuid: async (organizationUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUuid' is not null or undefined
            assertParamExists('getConversationByOrganizationAdminUuid', 'organizationUuid', organizationUuid)
            const localVarPath = `/conversation/organization-admin/{organizationUuid}`
                .replace(`{${"organizationUuid"}}`, encodeURIComponent(String(organizationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get conversations by user uuid
         * @param {string} uuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationByUserUuid: async (uuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getConversationByUserUuid', 'uuid', uuid)
            const localVarPath = `/conversation/user/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversationsApi - functional programming interface
 * @export
 */
export const ConversationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create conversations
         * @param {NewConversations} newConversations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConversations(newConversations: NewConversations, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedCreatedConversation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConversations(newConversations, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get conversations
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversation(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedConversation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversation(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get conversations by admin uuid
         * @param {string} uuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationByAdminUuid(uuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedConversationByAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationByAdminUuid(uuid, limit, offset, direction, column, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get conversations by organization admin uuid
         * @param {string} organizationUuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationByOrganizationAdminUuid(organizationUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedConversationByOrganizationAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationByOrganizationAdminUuid(organizationUuid, limit, offset, direction, column, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get conversations by user uuid
         * @param {string} uuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationByUserUuid(uuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedConversation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationByUserUuid(uuid, limit, offset, direction, column, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConversationsApi - factory interface
 * @export
 */
export const ConversationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create conversations
         * @param {NewConversations} newConversations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversations(newConversations: NewConversations, options?: any): AxiosPromise<EnvelopedCreatedConversation> {
            return localVarFp.createConversations(newConversations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get conversations
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation(uuid: string, options?: any): AxiosPromise<EnvelopedConversation> {
            return localVarFp.getConversation(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get conversations by admin uuid
         * @param {string} uuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationByAdminUuid(uuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: any): AxiosPromise<EnvelopedPaginatedConversationByAdmin> {
            return localVarFp.getConversationByAdminUuid(uuid, limit, offset, direction, column, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get conversations by organization admin uuid
         * @param {string} organizationUuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationByOrganizationAdminUuid(organizationUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: any): AxiosPromise<EnvelopedPaginatedConversationByOrganizationAdmin> {
            return localVarFp.getConversationByOrganizationAdminUuid(organizationUuid, limit, offset, direction, column, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get conversations by user uuid
         * @param {string} uuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationByUserUuid(uuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: any): AxiosPromise<EnvelopedPaginatedConversation> {
            return localVarFp.getConversationByUserUuid(uuid, limit, offset, direction, column, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConversationsApi - object-oriented interface
 * @export
 * @class ConversationsApi
 * @extends {BaseAPI}
 */
export class ConversationsApi extends BaseAPI {
    /**
     * 
     * @summary Create conversations
     * @param {NewConversations} newConversations 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public createConversations(newConversations: NewConversations, options?: AxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).createConversations(newConversations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get conversations
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public getConversation(uuid: string, options?: AxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).getConversation(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get conversations by admin uuid
     * @param {string} uuid 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public getConversationByAdminUuid(uuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).getConversationByAdminUuid(uuid, limit, offset, direction, column, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get conversations by organization admin uuid
     * @param {string} organizationUuid 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public getConversationByOrganizationAdminUuid(organizationUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).getConversationByOrganizationAdminUuid(organizationUuid, limit, offset, direction, column, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get conversations by user uuid
     * @param {string} uuid 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public getConversationByUserUuid(uuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).getConversationByUserUuid(uuid, limit, offset, direction, column, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MaterialGroupsApi - axios parameter creator
 * @export
 */
export const MaterialGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create materialGroup
         * @param {NewMaterialGroup} [newMaterialGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaterialGroup: async (newMaterialGroup?: NewMaterialGroup, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/material-group/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newMaterialGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete materialGroup by id
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaterialGroupById: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteMaterialGroupById', 'uuid', uuid)
            const localVarPath = `/material-group/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get material group
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {boolean} [includeMaterials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialGroup: async (limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, includeMaterials?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/material-group/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }

            if (includeMaterials !== undefined) {
                localVarQueryParameter['includeMaterials'] = includeMaterials;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get materialGroup by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialGroupByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getMaterialGroupByUuid', 'uuid', uuid)
            const localVarPath = `/material-group/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update materialGroup by id
         * @param {string} uuid 
         * @param {UpdateMaterialGroup} updateMaterialGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaterialGroupByUuId: async (uuid: string, updateMaterialGroup: UpdateMaterialGroup, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateMaterialGroupByUuId', 'uuid', uuid)
            // verify required parameter 'updateMaterialGroup' is not null or undefined
            assertParamExists('updateMaterialGroupByUuId', 'updateMaterialGroup', updateMaterialGroup)
            const localVarPath = `/material-group/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMaterialGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaterialGroupsApi - functional programming interface
 * @export
 */
export const MaterialGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaterialGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create materialGroup
         * @param {NewMaterialGroup} [newMaterialGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMaterialGroup(newMaterialGroup?: NewMaterialGroup, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedCreatedMaterialGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMaterialGroup(newMaterialGroup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete materialGroup by id
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMaterialGroupById(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMaterialGroupById(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get material group
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {boolean} [includeMaterials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterialGroup(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, includeMaterials?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedMaterialGroupList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterialGroup(limit, offset, direction, column, includeDeleted, includeMaterials, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get materialGroup by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterialGroupByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedMaterialGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterialGroupByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update materialGroup by id
         * @param {string} uuid 
         * @param {UpdateMaterialGroup} updateMaterialGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaterialGroupByUuId(uuid: string, updateMaterialGroup: UpdateMaterialGroup, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedMaterialGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMaterialGroupByUuId(uuid, updateMaterialGroup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MaterialGroupsApi - factory interface
 * @export
 */
export const MaterialGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaterialGroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create materialGroup
         * @param {NewMaterialGroup} [newMaterialGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaterialGroup(newMaterialGroup?: NewMaterialGroup, options?: any): AxiosPromise<EnvelopedCreatedMaterialGroup> {
            return localVarFp.createMaterialGroup(newMaterialGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete materialGroup by id
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaterialGroupById(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMaterialGroupById(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get material group
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {boolean} [includeMaterials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialGroup(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, includeMaterials?: boolean, options?: any): AxiosPromise<EnvelopedPaginatedMaterialGroupList> {
            return localVarFp.getMaterialGroup(limit, offset, direction, column, includeDeleted, includeMaterials, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get materialGroup by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialGroupByUuid(uuid: string, options?: any): AxiosPromise<EnvelopedMaterialGroup> {
            return localVarFp.getMaterialGroupByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update materialGroup by id
         * @param {string} uuid 
         * @param {UpdateMaterialGroup} updateMaterialGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaterialGroupByUuId(uuid: string, updateMaterialGroup: UpdateMaterialGroup, options?: any): AxiosPromise<EnvelopedMaterialGroup> {
            return localVarFp.updateMaterialGroupByUuId(uuid, updateMaterialGroup, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaterialGroupsApi - object-oriented interface
 * @export
 * @class MaterialGroupsApi
 * @extends {BaseAPI}
 */
export class MaterialGroupsApi extends BaseAPI {
    /**
     * 
     * @summary Create materialGroup
     * @param {NewMaterialGroup} [newMaterialGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialGroupsApi
     */
    public createMaterialGroup(newMaterialGroup?: NewMaterialGroup, options?: AxiosRequestConfig) {
        return MaterialGroupsApiFp(this.configuration).createMaterialGroup(newMaterialGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete materialGroup by id
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialGroupsApi
     */
    public deleteMaterialGroupById(uuid: string, options?: AxiosRequestConfig) {
        return MaterialGroupsApiFp(this.configuration).deleteMaterialGroupById(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get material group
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {boolean} [includeDeleted] 
     * @param {boolean} [includeMaterials] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialGroupsApi
     */
    public getMaterialGroup(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, includeMaterials?: boolean, options?: AxiosRequestConfig) {
        return MaterialGroupsApiFp(this.configuration).getMaterialGroup(limit, offset, direction, column, includeDeleted, includeMaterials, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get materialGroup by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialGroupsApi
     */
    public getMaterialGroupByUuid(uuid: string, options?: AxiosRequestConfig) {
        return MaterialGroupsApiFp(this.configuration).getMaterialGroupByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update materialGroup by id
     * @param {string} uuid 
     * @param {UpdateMaterialGroup} updateMaterialGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialGroupsApi
     */
    public updateMaterialGroupByUuId(uuid: string, updateMaterialGroup: UpdateMaterialGroup, options?: AxiosRequestConfig) {
        return MaterialGroupsApiFp(this.configuration).updateMaterialGroupByUuId(uuid, updateMaterialGroup, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MaterialsApi - axios parameter creator
 * @export
 */
export const MaterialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create material
         * @param {NewMaterial} [newMaterial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaterial: async (newMaterial?: NewMaterial, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/material/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newMaterial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete material by id
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaterialById: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteMaterialById', 'uuid', uuid)
            const localVarPath = `/material/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get material
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterial: async (limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/material/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get material by remove deleted
         * @param {string} materialGroupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialByRemoveDeleted: async (materialGroupUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialGroupUuid' is not null or undefined
            assertParamExists('getMaterialByRemoveDeleted', 'materialGroupUuid', materialGroupUuid)
            const localVarPath = `/material/present/{materialGroupUuid}`
                .replace(`{${"materialGroupUuid"}}`, encodeURIComponent(String(materialGroupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get material by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getMaterialByUuid', 'uuid', uuid)
            const localVarPath = `/material/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update material by id
         * @param {string} uuid 
         * @param {UpdateMaterial} updateMaterial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaterialByUuid: async (uuid: string, updateMaterial: UpdateMaterial, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateMaterialByUuid', 'uuid', uuid)
            // verify required parameter 'updateMaterial' is not null or undefined
            assertParamExists('updateMaterialByUuid', 'updateMaterial', updateMaterial)
            const localVarPath = `/material/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMaterial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update material group sort by uuid
         * @param {string} uuid 
         * @param {UpdateMaterialGroupSort} updateMaterialGroupSort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaterialGroupSortByUuId: async (uuid: string, updateMaterialGroupSort: UpdateMaterialGroupSort, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateMaterialGroupSortByUuId', 'uuid', uuid)
            // verify required parameter 'updateMaterialGroupSort' is not null or undefined
            assertParamExists('updateMaterialGroupSortByUuId', 'updateMaterialGroupSort', updateMaterialGroupSort)
            const localVarPath = `/material-group/sort/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMaterialGroupSort, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update material sort by id
         * @param {string} uuid 
         * @param {UpdateMaterialSort} updateMaterialSort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaterialSortByUuId: async (uuid: string, updateMaterialSort: UpdateMaterialSort, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateMaterialSortByUuId', 'uuid', uuid)
            // verify required parameter 'updateMaterialSort' is not null or undefined
            assertParamExists('updateMaterialSortByUuId', 'updateMaterialSort', updateMaterialSort)
            const localVarPath = `/material/sort/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMaterialSort, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaterialsApi - functional programming interface
 * @export
 */
export const MaterialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaterialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create material
         * @param {NewMaterial} [newMaterial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMaterial(newMaterial?: NewMaterial, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedMaterial>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMaterial(newMaterial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete material by id
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMaterialById(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMaterialById(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get material
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterial(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedMaterialList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterial(limit, offset, direction, column, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get material by remove deleted
         * @param {string} materialGroupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterialByRemoveDeleted(materialGroupUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPresentMaterials>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterialByRemoveDeleted(materialGroupUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get material by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterialByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedMaterial>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterialByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update material by id
         * @param {string} uuid 
         * @param {UpdateMaterial} updateMaterial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaterialByUuid(uuid: string, updateMaterial: UpdateMaterial, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedMaterial>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMaterialByUuid(uuid, updateMaterial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update material group sort by uuid
         * @param {string} uuid 
         * @param {UpdateMaterialGroupSort} updateMaterialGroupSort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaterialGroupSortByUuId(uuid: string, updateMaterialGroupSort: UpdateMaterialGroupSort, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedSortedMaterialGroups>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMaterialGroupSortByUuId(uuid, updateMaterialGroupSort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update material sort by id
         * @param {string} uuid 
         * @param {UpdateMaterialSort} updateMaterialSort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaterialSortByUuId(uuid: string, updateMaterialSort: UpdateMaterialSort, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedSortedMaterials>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMaterialSortByUuId(uuid, updateMaterialSort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MaterialsApi - factory interface
 * @export
 */
export const MaterialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaterialsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create material
         * @param {NewMaterial} [newMaterial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaterial(newMaterial?: NewMaterial, options?: any): AxiosPromise<EnvelopedMaterial> {
            return localVarFp.createMaterial(newMaterial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete material by id
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaterialById(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMaterialById(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get material
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterial(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: any): AxiosPromise<EnvelopedPaginatedMaterialList> {
            return localVarFp.getMaterial(limit, offset, direction, column, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get material by remove deleted
         * @param {string} materialGroupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialByRemoveDeleted(materialGroupUuid: string, options?: any): AxiosPromise<EnvelopedPresentMaterials> {
            return localVarFp.getMaterialByRemoveDeleted(materialGroupUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get material by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterialByUuid(uuid: string, options?: any): AxiosPromise<EnvelopedMaterial> {
            return localVarFp.getMaterialByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update material by id
         * @param {string} uuid 
         * @param {UpdateMaterial} updateMaterial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaterialByUuid(uuid: string, updateMaterial: UpdateMaterial, options?: any): AxiosPromise<EnvelopedMaterial> {
            return localVarFp.updateMaterialByUuid(uuid, updateMaterial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update material group sort by uuid
         * @param {string} uuid 
         * @param {UpdateMaterialGroupSort} updateMaterialGroupSort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaterialGroupSortByUuId(uuid: string, updateMaterialGroupSort: UpdateMaterialGroupSort, options?: any): AxiosPromise<EnvelopedSortedMaterialGroups> {
            return localVarFp.updateMaterialGroupSortByUuId(uuid, updateMaterialGroupSort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update material sort by id
         * @param {string} uuid 
         * @param {UpdateMaterialSort} updateMaterialSort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaterialSortByUuId(uuid: string, updateMaterialSort: UpdateMaterialSort, options?: any): AxiosPromise<EnvelopedSortedMaterials> {
            return localVarFp.updateMaterialSortByUuId(uuid, updateMaterialSort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaterialsApi - object-oriented interface
 * @export
 * @class MaterialsApi
 * @extends {BaseAPI}
 */
export class MaterialsApi extends BaseAPI {
    /**
     * 
     * @summary Create material
     * @param {NewMaterial} [newMaterial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialsApi
     */
    public createMaterial(newMaterial?: NewMaterial, options?: AxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).createMaterial(newMaterial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete material by id
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialsApi
     */
    public deleteMaterialById(uuid: string, options?: AxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).deleteMaterialById(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get material
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialsApi
     */
    public getMaterial(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).getMaterial(limit, offset, direction, column, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get material by remove deleted
     * @param {string} materialGroupUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialsApi
     */
    public getMaterialByRemoveDeleted(materialGroupUuid: string, options?: AxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).getMaterialByRemoveDeleted(materialGroupUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get material by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialsApi
     */
    public getMaterialByUuid(uuid: string, options?: AxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).getMaterialByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update material by id
     * @param {string} uuid 
     * @param {UpdateMaterial} updateMaterial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialsApi
     */
    public updateMaterialByUuid(uuid: string, updateMaterial: UpdateMaterial, options?: AxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).updateMaterialByUuid(uuid, updateMaterial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update material group sort by uuid
     * @param {string} uuid 
     * @param {UpdateMaterialGroupSort} updateMaterialGroupSort 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialsApi
     */
    public updateMaterialGroupSortByUuId(uuid: string, updateMaterialGroupSort: UpdateMaterialGroupSort, options?: AxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).updateMaterialGroupSortByUuId(uuid, updateMaterialGroupSort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update material sort by id
     * @param {string} uuid 
     * @param {UpdateMaterialSort} updateMaterialSort 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialsApi
     */
    public updateMaterialSortByUuId(uuid: string, updateMaterialSort: UpdateMaterialSort, options?: AxiosRequestConfig) {
        return MaterialsApiFp(this.configuration).updateMaterialSortByUuId(uuid, updateMaterialSort, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get message
         * @param {string} conversationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage: async (conversationId: string, limit?: number, offset?: number, direction?: SortDirection, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getMessage', 'conversationId', conversationId)
            const localVarPath = `/message/{conversationId}`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get new message count
         * @param {string} uuid 
         * @param {NewMessageCount} newMessageCount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewMessageCount: async (uuid: string, newMessageCount: NewMessageCount, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getNewMessageCount', 'uuid', uuid)
            // verify required parameter 'newMessageCount' is not null or undefined
            assertParamExists('getNewMessageCount', 'newMessageCount', newMessageCount)
            const localVarPath = `/message/new/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newMessageCount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch read flag
         * @param {string} userUuid 
         * @param {string} conversationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReadFlag: async (userUuid: string, conversationUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('patchReadFlag', 'userUuid', userUuid)
            // verify required parameter 'conversationUuid' is not null or undefined
            assertParamExists('patchReadFlag', 'conversationUuid', conversationUuid)
            const localVarPath = `/message/{userUuid}/{conversationUuid}`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)))
                .replace(`{${"conversationUuid"}}`, encodeURIComponent(String(conversationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post message
         * @param {NewMessages} newMessages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessage: async (newMessages: NewMessages, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newMessages' is not null or undefined
            assertParamExists('postMessage', 'newMessages', newMessages)
            const localVarPath = `/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newMessages, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get message
         * @param {string} conversationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessage(conversationId: string, limit?: number, offset?: number, direction?: SortDirection, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedMessageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessage(conversationId, limit, offset, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get new message count
         * @param {string} uuid 
         * @param {NewMessageCount} newMessageCount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewMessageCount(uuid: string, newMessageCount: NewMessageCount, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedGetNewMessageCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewMessageCount(uuid, newMessageCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Patch read flag
         * @param {string} userUuid 
         * @param {string} conversationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchReadFlag(userUuid: string, conversationUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPatchReadFlag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchReadFlag(userUuid, conversationUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post message
         * @param {NewMessages} newMessages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMessage(newMessages: NewMessages, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMessage(newMessages, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get message
         * @param {string} conversationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage(conversationId: string, limit?: number, offset?: number, direction?: SortDirection, options?: any): AxiosPromise<EnvelopedPaginatedMessageList> {
            return localVarFp.getMessage(conversationId, limit, offset, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get new message count
         * @param {string} uuid 
         * @param {NewMessageCount} newMessageCount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewMessageCount(uuid: string, newMessageCount: NewMessageCount, options?: any): AxiosPromise<EnvelopedGetNewMessageCount> {
            return localVarFp.getNewMessageCount(uuid, newMessageCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch read flag
         * @param {string} userUuid 
         * @param {string} conversationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReadFlag(userUuid: string, conversationUuid: string, options?: any): AxiosPromise<EnvelopedPatchReadFlag> {
            return localVarFp.patchReadFlag(userUuid, conversationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post message
         * @param {NewMessages} newMessages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessage(newMessages: NewMessages, options?: any): AxiosPromise<EnvelopedMessage> {
            return localVarFp.postMessage(newMessages, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
    /**
     * 
     * @summary Get message
     * @param {string} conversationId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getMessage(conversationId: string, limit?: number, offset?: number, direction?: SortDirection, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getMessage(conversationId, limit, offset, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get new message count
     * @param {string} uuid 
     * @param {NewMessageCount} newMessageCount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getNewMessageCount(uuid: string, newMessageCount: NewMessageCount, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getNewMessageCount(uuid, newMessageCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch read flag
     * @param {string} userUuid 
     * @param {string} conversationUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public patchReadFlag(userUuid: string, conversationUuid: string, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).patchReadFlag(userUuid, conversationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post message
     * @param {NewMessages} newMessages 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public postMessage(newMessages: NewMessages, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).postMessage(newMessages, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NewsApi - axios parameter creator
 * @export
 */
export const NewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create news
         * @param {NewNews} newNews 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNews: async (newNews: NewNews, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newNews' is not null or undefined
            assertParamExists('createNews', 'newNews', newNews)
            const localVarPath = `/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newNews, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete news by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNewsByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteNewsByUuid', 'uuid', uuid)
            const localVarPath = `/news/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get news by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getNewsByUuid', 'uuid', uuid)
            const localVarPath = `/news/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update news by uuid
         * @param {string} uuid 
         * @param {UpdateNews} updateNews 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNewsByUuid: async (uuid: string, updateNews: UpdateNews, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateNewsByUuid', 'uuid', uuid)
            // verify required parameter 'updateNews' is not null or undefined
            assertParamExists('updateNewsByUuid', 'updateNews', updateNews)
            const localVarPath = `/news/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNews, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsApi - functional programming interface
 * @export
 */
export const NewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NewsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create news
         * @param {NewNews} newNews 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNews(newNews: NewNews, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedNews>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNews(newNews, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete news by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNewsByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNewsByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNews(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedNewsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNews(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get news by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedNews>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update news by uuid
         * @param {string} uuid 
         * @param {UpdateNews} updateNews 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNewsByUuid(uuid: string, updateNews: UpdateNews, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedNews>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNewsByUuid(uuid, updateNews, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NewsApi - factory interface
 * @export
 */
export const NewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NewsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create news
         * @param {NewNews} newNews 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNews(newNews: NewNews, options?: any): AxiosPromise<EnvelopedNews> {
            return localVarFp.createNews(newNews, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete news by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNewsByUuid(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteNewsByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews(options?: any): AxiosPromise<EnvelopedPaginatedNewsList> {
            return localVarFp.getNews(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get news by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsByUuid(uuid: string, options?: any): AxiosPromise<EnvelopedNews> {
            return localVarFp.getNewsByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update news by uuid
         * @param {string} uuid 
         * @param {UpdateNews} updateNews 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNewsByUuid(uuid: string, updateNews: UpdateNews, options?: any): AxiosPromise<EnvelopedNews> {
            return localVarFp.updateNewsByUuid(uuid, updateNews, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NewsApi - object-oriented interface
 * @export
 * @class NewsApi
 * @extends {BaseAPI}
 */
export class NewsApi extends BaseAPI {
    /**
     * 
     * @summary Create news
     * @param {NewNews} newNews 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public createNews(newNews: NewNews, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).createNews(newNews, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete news by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public deleteNewsByUuid(uuid: string, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).deleteNewsByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all news
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getNews(options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).getNews(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get news by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getNewsByUuid(uuid: string, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).getNewsByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update news by uuid
     * @param {string} uuid 
     * @param {UpdateNews} updateNews 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public updateNewsByUuid(uuid: string, updateNews: UpdateNews, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).updateNewsByUuid(uuid, updateNews, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationAdminsApi - axios parameter creator
 * @export
 */
export const OrganizationAdminsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create organization admin
         * @param {NewOrganizationAdmin} [newOrganizationAdmin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationAdmin: async (newOrganizationAdmin?: NewOrganizationAdmin, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newOrganizationAdmin, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete organization admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationAdminByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteOrganizationAdminByUuid', 'uuid', uuid)
            const localVarPath = `/organization-admin/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAdminByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getOrganizationAdminByUuid', 'uuid', uuid)
            const localVarPath = `/organization-admin/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization admins
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {string} [organizationUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAdmins: async (limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, organizationUuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }

            if (organizationUuid !== undefined) {
                localVarQueryParameter['organizationUuid'] = organizationUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update organization admin by uuid
         * @param {string} uuid 
         * @param {UpdateOrganizationAdmin} [updateOrganizationAdmin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationAdminByUuid: async (uuid: string, updateOrganizationAdmin?: UpdateOrganizationAdmin, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateOrganizationAdminByUuid', 'uuid', uuid)
            const localVarPath = `/organization-admin/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationAdmin, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationAdminsApi - functional programming interface
 * @export
 */
export const OrganizationAdminsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationAdminsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create organization admin
         * @param {NewOrganizationAdmin} [newOrganizationAdmin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationAdmin(newOrganizationAdmin?: NewOrganizationAdmin, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganizationAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationAdmin(newOrganizationAdmin, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete organization admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationAdminByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationAdminByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationAdminByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganizationAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationAdminByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization admins
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {string} [organizationUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationAdmins(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, organizationUuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedOrganizationAdminList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationAdmins(limit, offset, direction, column, includeDeleted, organizationUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update organization admin by uuid
         * @param {string} uuid 
         * @param {UpdateOrganizationAdmin} [updateOrganizationAdmin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationAdminByUuid(uuid: string, updateOrganizationAdmin?: UpdateOrganizationAdmin, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganizationAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationAdminByUuid(uuid, updateOrganizationAdmin, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationAdminsApi - factory interface
 * @export
 */
export const OrganizationAdminsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationAdminsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create organization admin
         * @param {NewOrganizationAdmin} [newOrganizationAdmin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationAdmin(newOrganizationAdmin?: NewOrganizationAdmin, options?: any): AxiosPromise<EnvelopedOrganizationAdmin> {
            return localVarFp.createOrganizationAdmin(newOrganizationAdmin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete organization admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationAdminByUuid(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteOrganizationAdminByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization admin by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAdminByUuid(uuid: string, options?: any): AxiosPromise<EnvelopedOrganizationAdmin> {
            return localVarFp.getOrganizationAdminByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization admins
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {string} [organizationUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAdmins(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, organizationUuid?: string, options?: any): AxiosPromise<EnvelopedPaginatedOrganizationAdminList> {
            return localVarFp.getOrganizationAdmins(limit, offset, direction, column, includeDeleted, organizationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update organization admin by uuid
         * @param {string} uuid 
         * @param {UpdateOrganizationAdmin} [updateOrganizationAdmin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationAdminByUuid(uuid: string, updateOrganizationAdmin?: UpdateOrganizationAdmin, options?: any): AxiosPromise<EnvelopedOrganizationAdmin> {
            return localVarFp.updateOrganizationAdminByUuid(uuid, updateOrganizationAdmin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationAdminsApi - object-oriented interface
 * @export
 * @class OrganizationAdminsApi
 * @extends {BaseAPI}
 */
export class OrganizationAdminsApi extends BaseAPI {
    /**
     * 
     * @summary Create organization admin
     * @param {NewOrganizationAdmin} [newOrganizationAdmin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminsApi
     */
    public createOrganizationAdmin(newOrganizationAdmin?: NewOrganizationAdmin, options?: AxiosRequestConfig) {
        return OrganizationAdminsApiFp(this.configuration).createOrganizationAdmin(newOrganizationAdmin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete organization admin by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminsApi
     */
    public deleteOrganizationAdminByUuid(uuid: string, options?: AxiosRequestConfig) {
        return OrganizationAdminsApiFp(this.configuration).deleteOrganizationAdminByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization admin by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminsApi
     */
    public getOrganizationAdminByUuid(uuid: string, options?: AxiosRequestConfig) {
        return OrganizationAdminsApiFp(this.configuration).getOrganizationAdminByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization admins
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {boolean} [includeDeleted] 
     * @param {string} [organizationUuid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminsApi
     */
    public getOrganizationAdmins(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, organizationUuid?: string, options?: AxiosRequestConfig) {
        return OrganizationAdminsApiFp(this.configuration).getOrganizationAdmins(limit, offset, direction, column, includeDeleted, organizationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update organization admin by uuid
     * @param {string} uuid 
     * @param {UpdateOrganizationAdmin} [updateOrganizationAdmin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminsApi
     */
    public updateOrganizationAdminByUuid(uuid: string, updateOrganizationAdmin?: UpdateOrganizationAdmin, options?: AxiosRequestConfig) {
        return OrganizationAdminsApiFp(this.configuration).updateOrganizationAdminByUuid(uuid, updateOrganizationAdmin, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationUsersApi - axios parameter creator
 * @export
 */
export const OrganizationUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExpirationDate: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('checkExpirationDate', 'uuid', uuid)
            const localVarPath = `/organization-user/check-expiration-date/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create organization user
         * @param {NewOrganizationUser} [newOrganizationUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationUser: async (newOrganizationUser?: NewOrganizationUser, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newOrganizationUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete organization user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationUserByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteOrganizationUserByUuid', 'uuid', uuid)
            const localVarPath = `/organization-user/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUserByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getOrganizationUserByUuid', 'uuid', uuid)
            const localVarPath = `/organization-user/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization users
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {string} [organizationUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUsers: async (limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, organizationUuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }

            if (organizationUuid !== undefined) {
                localVarQueryParameter['organizationUuid'] = organizationUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update organization user by uuid
         * @param {string} uuid 
         * @param {UpdateOrganizationUser} [updateOrganizationUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUserByUuid: async (uuid: string, updateOrganizationUser?: UpdateOrganizationUser, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateOrganizationUserByUuid', 'uuid', uuid)
            const localVarPath = `/organization-user/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationUsersApi - functional programming interface
 * @export
 */
export const OrganizationUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkExpirationDate(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkExpirationDate(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create organization user
         * @param {NewOrganizationUser} [newOrganizationUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationUser(newOrganizationUser?: NewOrganizationUser, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationUser(newOrganizationUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete organization user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationUserByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationUserByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationUserByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationUserByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization users
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {string} [organizationUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationUsers(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, organizationUuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedOrganizationUserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationUsers(limit, offset, direction, column, includeDeleted, organizationUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update organization user by uuid
         * @param {string} uuid 
         * @param {UpdateOrganizationUser} [updateOrganizationUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationUserByUuid(uuid: string, updateOrganizationUser?: UpdateOrganizationUser, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationUserByUuid(uuid, updateOrganizationUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationUsersApi - factory interface
 * @export
 */
export const OrganizationUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationUsersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExpirationDate(uuid: string, options?: any): AxiosPromise<EnvelopedOrganizationUser> {
            return localVarFp.checkExpirationDate(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create organization user
         * @param {NewOrganizationUser} [newOrganizationUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationUser(newOrganizationUser?: NewOrganizationUser, options?: any): AxiosPromise<EnvelopedOrganizationUser> {
            return localVarFp.createOrganizationUser(newOrganizationUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete organization user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationUserByUuid(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteOrganizationUserByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUserByUuid(uuid: string, options?: any): AxiosPromise<EnvelopedOrganizationUser> {
            return localVarFp.getOrganizationUserByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization users
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {string} [organizationUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUsers(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, organizationUuid?: string, options?: any): AxiosPromise<EnvelopedPaginatedOrganizationUserList> {
            return localVarFp.getOrganizationUsers(limit, offset, direction, column, includeDeleted, organizationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update organization user by uuid
         * @param {string} uuid 
         * @param {UpdateOrganizationUser} [updateOrganizationUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUserByUuid(uuid: string, updateOrganizationUser?: UpdateOrganizationUser, options?: any): AxiosPromise<EnvelopedOrganizationUser> {
            return localVarFp.updateOrganizationUserByUuid(uuid, updateOrganizationUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationUsersApi - object-oriented interface
 * @export
 * @class OrganizationUsersApi
 * @extends {BaseAPI}
 */
export class OrganizationUsersApi extends BaseAPI {
    /**
     * 
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApi
     */
    public checkExpirationDate(uuid: string, options?: AxiosRequestConfig) {
        return OrganizationUsersApiFp(this.configuration).checkExpirationDate(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create organization user
     * @param {NewOrganizationUser} [newOrganizationUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApi
     */
    public createOrganizationUser(newOrganizationUser?: NewOrganizationUser, options?: AxiosRequestConfig) {
        return OrganizationUsersApiFp(this.configuration).createOrganizationUser(newOrganizationUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete organization user by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApi
     */
    public deleteOrganizationUserByUuid(uuid: string, options?: AxiosRequestConfig) {
        return OrganizationUsersApiFp(this.configuration).deleteOrganizationUserByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization user by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApi
     */
    public getOrganizationUserByUuid(uuid: string, options?: AxiosRequestConfig) {
        return OrganizationUsersApiFp(this.configuration).getOrganizationUserByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization users
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {boolean} [includeDeleted] 
     * @param {string} [organizationUuid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApi
     */
    public getOrganizationUsers(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, organizationUuid?: string, options?: AxiosRequestConfig) {
        return OrganizationUsersApiFp(this.configuration).getOrganizationUsers(limit, offset, direction, column, includeDeleted, organizationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update organization user by uuid
     * @param {string} uuid 
     * @param {UpdateOrganizationUser} [updateOrganizationUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApi
     */
    public updateOrganizationUserByUuid(uuid: string, updateOrganizationUser?: UpdateOrganizationUser, options?: AxiosRequestConfig) {
        return OrganizationUsersApiFp(this.configuration).updateOrganizationUserByUuid(uuid, updateOrganizationUser, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create organization
         * @param {NewOrganization} [newOrganization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization: async (newOrganization?: NewOrganization, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newOrganization, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete organization by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteOrganizationByUuid', 'uuid', uuid)
            const localVarPath = `/organization/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organizations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations: async (limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organizations by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getOrganizationsByUuid', 'uuid', uuid)
            const localVarPath = `/organization/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update organization by uuid
         * @param {string} uuid 
         * @param {UpdateOrganization} [updateOrganization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationByUuid: async (uuid: string, updateOrganization?: UpdateOrganization, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateOrganizationByUuid', 'uuid', uuid)
            const localVarPath = `/organization/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganization, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create organization
         * @param {NewOrganization} [newOrganization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganization(newOrganization?: NewOrganization, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganization(newOrganization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete organization by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organizations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizations(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedOrganizationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizations(limit, offset, direction, column, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organizations by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update organization by uuid
         * @param {string} uuid 
         * @param {UpdateOrganization} [updateOrganization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationByUuid(uuid: string, updateOrganization?: UpdateOrganization, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedOrganization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationByUuid(uuid, updateOrganization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create organization
         * @param {NewOrganization} [newOrganization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(newOrganization?: NewOrganization, options?: any): AxiosPromise<EnvelopedOrganization> {
            return localVarFp.createOrganization(newOrganization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete organization by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationByUuid(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteOrganizationByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organizations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: any): AxiosPromise<EnvelopedPaginatedOrganizationList> {
            return localVarFp.getOrganizations(limit, offset, direction, column, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organizations by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsByUuid(uuid: string, options?: any): AxiosPromise<EnvelopedOrganization> {
            return localVarFp.getOrganizationsByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update organization by uuid
         * @param {string} uuid 
         * @param {UpdateOrganization} [updateOrganization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationByUuid(uuid: string, updateOrganization?: UpdateOrganization, options?: any): AxiosPromise<EnvelopedOrganization> {
            return localVarFp.updateOrganizationByUuid(uuid, updateOrganization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * 
     * @summary Create organization
     * @param {NewOrganization} [newOrganization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public createOrganization(newOrganization?: NewOrganization, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createOrganization(newOrganization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete organization by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public deleteOrganizationByUuid(uuid: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteOrganizationByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organizations
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizations(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizations(limit, offset, direction, column, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organizations by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationsByUuid(uuid: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationsByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update organization by uuid
     * @param {string} uuid 
     * @param {UpdateOrganization} [updateOrganization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationByUuid(uuid: string, updateOrganization?: UpdateOrganization, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganizationByUuid(uuid, updateOrganization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StripeApi - axios parameter creator
 * @export
 */
export const StripeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary all Get Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetCoupon: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/coupons/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary all get Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetCustomer: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/customer/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary all get Plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetPlan: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/plan/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary all get Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetProduct: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/product/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary all get Promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetPromos: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/promo/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary all get Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetSubscription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/subscription/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create Card
         * @param {CreateCard} [createCard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCard: async (createCard?: CreateCard, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/card/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCard, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create Customer
         * @param {CreateCustomer} [createCustomer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: async (createCustomer?: CreateCustomer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/customer/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create Subscription
         * @param {CreateSubscription} [createSubscription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: async (createSubscription?: CreateSubscription, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/subscription/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubscription, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Card by CusId & CardId
         * @param {string} cusId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCardByCusIdCardId: async (cusId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cusId' is not null or undefined
            assertParamExists('deleteCardByCusIdCardId', 'cusId', cusId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('deleteCardByCusIdCardId', 'cardId', cardId)
            const localVarPath = `/stripe/card/{cusId}/sources/{cardId}`
                .replace(`{${"cusId"}}`, encodeURIComponent(String(cusId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Customer by cusId
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerByCusId: async (cusId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cusId' is not null or undefined
            assertParamExists('deleteCustomerByCusId', 'cusId', cusId)
            const localVarPath = `/stripe/customer/{cusId}`
                .replace(`{${"cusId"}}`, encodeURIComponent(String(cusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Subscription by subId
         * @param {string} subId 
         * @param {string} userUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionBySubId: async (subId: string, userUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subId' is not null or undefined
            assertParamExists('deleteSubscriptionBySubId', 'subId', subId)
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('deleteSubscriptionBySubId', 'userUuid', userUuid)
            const localVarPath = `/stripe/subscription/{subId}/{userUuid}`
                .replace(`{${"subId"}}`, encodeURIComponent(String(subId)))
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Card by Cusid
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardByCusId: async (cusId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cusId' is not null or undefined
            assertParamExists('getCardByCusId', 'cusId', cusId)
            const localVarPath = `/stripe/card/{cusId}`
                .replace(`{${"cusId"}}`, encodeURIComponent(String(cusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Card by CusId & CardId
         * @param {string} cusId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardByCusIdCardId: async (cusId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cusId' is not null or undefined
            assertParamExists('getCardByCusIdCardId', 'cusId', cusId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCardByCusIdCardId', 'cardId', cardId)
            const localVarPath = `/stripe/card/{cusId}/sources/{cardId}`
                .replace(`{${"cusId"}}`, encodeURIComponent(String(cusId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Coupon by couId
         * @param {string} couId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponByCouId: async (couId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couId' is not null or undefined
            assertParamExists('getCouponByCouId', 'couId', couId)
            const localVarPath = `/stripe/coupons/{couId}`
                .replace(`{${"couId"}}`, encodeURIComponent(String(couId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Customer by cusId
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerByCusId: async (cusId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cusId' is not null or undefined
            assertParamExists('getCustomerByCusId', 'cusId', cusId)
            const localVarPath = `/stripe/customer/{cusId}`
                .replace(`{${"cusId"}}`, encodeURIComponent(String(cusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post payment methods by cus id
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethodsByCusId: async (cusId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cusId' is not null or undefined
            assertParamExists('getPaymentMethodsByCusId', 'cusId', cusId)
            const localVarPath = `/stripe/payment-methods/{cusId}`
                .replace(`{${"cusId"}}`, encodeURIComponent(String(cusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Plan by planId
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanByPlanId: async (planId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('getPlanByPlanId', 'planId', planId)
            const localVarPath = `/stripe/plan/{planId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Product by prodId
         * @param {string} prodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByProdId: async (prodId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prodId' is not null or undefined
            assertParamExists('getProductByProdId', 'prodId', prodId)
            const localVarPath = `/stripe/product/{prodId}`
                .replace(`{${"prodId"}}`, encodeURIComponent(String(prodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Promos by promoId
         * @param {string} promoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromosByPromoId: async (promoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promoId' is not null or undefined
            assertParamExists('getPromosByPromoId', 'promoId', promoId)
            const localVarPath = `/stripe/promo/{promoId}`
                .replace(`{${"promoId"}}`, encodeURIComponent(String(promoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Subscription by cusId
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionByCusId: async (cusId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cusId' is not null or undefined
            assertParamExists('getSubscriptionByCusId', 'cusId', cusId)
            const localVarPath = `/stripe/subscription/customer/{cusId}`
                .replace(`{${"cusId"}}`, encodeURIComponent(String(cusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Subscription by subId
         * @param {string} subId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionBySubId: async (subId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subId' is not null or undefined
            assertParamExists('getSubscriptionBySubId', 'subId', subId)
            const localVarPath = `/stripe/subscription/{subId}`
                .replace(`{${"subId"}}`, encodeURIComponent(String(subId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post payment methods
         * @param {CreatePaymentMethods} [createPaymentMethods] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentMethods: async (createPaymentMethods?: CreatePaymentMethods, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/payment-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentMethods, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post update payment methods
         * @param {CreatePaymentMethods} [createPaymentMethods] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUpdatePaymentMethods: async (createPaymentMethods?: CreatePaymentMethods, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/payment-methods/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentMethods, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update Card
         * @param {UpdateCard} [updateCard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCard: async (updateCard?: UpdateCard, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/card/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCard, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update Customer
         * @param {UpdateCustomer} [updateCustomer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: async (updateCustomer?: UpdateCustomer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/customer/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update Subscription
         * @param {UpdateSubscription} [updateSubscription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: async (updateSubscription?: UpdateSubscription, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/subscription/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscription, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeApi - functional programming interface
 * @export
 */
export const StripeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary all Get Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allGetCoupon(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedCouponList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allGetCoupon(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary all get Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allGetCustomer(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Customer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allGetCustomer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary all get Plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allGetPlan(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPlanList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allGetPlan(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary all get Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allGetProduct(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedProductList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allGetProduct(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary all get Promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allGetPromos(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPromoList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allGetPromos(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary all get Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allGetSubscription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedSubscriptionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allGetSubscription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create Card
         * @param {CreateCard} [createCard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCard(createCard?: CreateCard, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Card>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCard(createCard, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create Customer
         * @param {CreateCustomer} [createCustomer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomer(createCustomer?: CreateCustomer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomer(createCustomer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create Subscription
         * @param {CreateSubscription} [createSubscription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubscription(createSubscription?: CreateSubscription, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubscription(createSubscription, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Card by CusId & CardId
         * @param {string} cusId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCardByCusIdCardId(cusId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCardByCusIdCardId(cusId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Customer by cusId
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerByCusId(cusId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteCustomer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerByCusId(cusId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Subscription by subId
         * @param {string} subId 
         * @param {string} userUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubscriptionBySubId(subId: string, userUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubscriptionBySubId(subId, userUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Card by Cusid
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardByCusId(cusId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Card>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardByCusId(cusId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Card by CusId & CardId
         * @param {string} cusId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardByCusIdCardId(cusId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Card>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardByCusIdCardId(cusId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Coupon by couId
         * @param {string} couId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponByCouId(couId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Coupon>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponByCouId(couId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Customer by cusId
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerByCusId(cusId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerByCusId(cusId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary post payment methods by cus id
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentMethodsByCusId(cusId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaymentList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentMethodsByCusId(cusId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Plan by planId
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanByPlanId(planId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanByPlanId(planId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Product by prodId
         * @param {string} prodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductByProdId(prodId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductByProdId(prodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Promos by promoId
         * @param {string} promoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromosByPromoId(promoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Promo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromosByPromoId(promoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Subscription by cusId
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionByCusId(cusId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedSubscriptionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionByCusId(cusId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Subscription by subId
         * @param {string} subId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionBySubId(subId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionBySubId(subId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary post payment methods
         * @param {CreatePaymentMethods} [createPaymentMethods] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPaymentMethods(createPaymentMethods?: CreatePaymentMethods, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPaymentMethods(createPaymentMethods, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary post update payment methods
         * @param {CreatePaymentMethods} [createPaymentMethods] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUpdatePaymentMethods(createPaymentMethods?: CreatePaymentMethods, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUpdatePaymentMethods(createPaymentMethods, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update Card
         * @param {UpdateCard} [updateCard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCard(updateCard?: UpdateCard, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Card>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCard(updateCard, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update Customer
         * @param {UpdateCustomer} [updateCustomer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomer(updateCustomer?: UpdateCustomer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomer(updateCustomer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update Subscription
         * @param {UpdateSubscription} [updateSubscription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscription(updateSubscription?: UpdateSubscription, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscription(updateSubscription, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StripeApi - factory interface
 * @export
 */
export const StripeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripeApiFp(configuration)
    return {
        /**
         * 
         * @summary all Get Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetCoupon(options?: any): AxiosPromise<EnvelopedCouponList> {
            return localVarFp.allGetCoupon(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary all get Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetCustomer(options?: any): AxiosPromise<Array<Customer>> {
            return localVarFp.allGetCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary all get Plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetPlan(options?: any): AxiosPromise<EnvelopedPlanList> {
            return localVarFp.allGetPlan(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary all get Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetProduct(options?: any): AxiosPromise<EnvelopedProductList> {
            return localVarFp.allGetProduct(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary all get Promos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetPromos(options?: any): AxiosPromise<EnvelopedPromoList> {
            return localVarFp.allGetPromos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary all get Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGetSubscription(options?: any): AxiosPromise<EnvelopedSubscriptionList> {
            return localVarFp.allGetSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create Card
         * @param {CreateCard} [createCard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCard(createCard?: CreateCard, options?: any): AxiosPromise<Card> {
            return localVarFp.createCard(createCard, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create Customer
         * @param {CreateCustomer} [createCustomer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(createCustomer?: CreateCustomer, options?: any): AxiosPromise<Customer> {
            return localVarFp.createCustomer(createCustomer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create Subscription
         * @param {CreateSubscription} [createSubscription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(createSubscription?: CreateSubscription, options?: any): AxiosPromise<Subscription> {
            return localVarFp.createSubscription(createSubscription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Card by CusId & CardId
         * @param {string} cusId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCardByCusIdCardId(cusId: string, cardId: string, options?: any): AxiosPromise<DeleteCard> {
            return localVarFp.deleteCardByCusIdCardId(cusId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Customer by cusId
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerByCusId(cusId: string, options?: any): AxiosPromise<DeleteCustomer> {
            return localVarFp.deleteCustomerByCusId(cusId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Subscription by subId
         * @param {string} subId 
         * @param {string} userUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionBySubId(subId: string, userUuid: string, options?: any): AxiosPromise<Subscription> {
            return localVarFp.deleteSubscriptionBySubId(subId, userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Card by Cusid
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardByCusId(cusId: string, options?: any): AxiosPromise<Array<Card>> {
            return localVarFp.getCardByCusId(cusId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Card by CusId & CardId
         * @param {string} cusId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardByCusIdCardId(cusId: string, cardId: string, options?: any): AxiosPromise<Card> {
            return localVarFp.getCardByCusIdCardId(cusId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Coupon by couId
         * @param {string} couId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponByCouId(couId: string, options?: any): AxiosPromise<Coupon> {
            return localVarFp.getCouponByCouId(couId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Customer by cusId
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerByCusId(cusId: string, options?: any): AxiosPromise<Customer> {
            return localVarFp.getCustomerByCusId(cusId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary post payment methods by cus id
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethodsByCusId(cusId: string, options?: any): AxiosPromise<EnvelopedPaymentList> {
            return localVarFp.getPaymentMethodsByCusId(cusId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Plan by planId
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanByPlanId(planId: string, options?: any): AxiosPromise<Plan> {
            return localVarFp.getPlanByPlanId(planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Product by prodId
         * @param {string} prodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByProdId(prodId: string, options?: any): AxiosPromise<Product> {
            return localVarFp.getProductByProdId(prodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Promos by promoId
         * @param {string} promoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromosByPromoId(promoId: string, options?: any): AxiosPromise<Promo> {
            return localVarFp.getPromosByPromoId(promoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Subscription by cusId
         * @param {string} cusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionByCusId(cusId: string, options?: any): AxiosPromise<EnvelopedSubscriptionList> {
            return localVarFp.getSubscriptionByCusId(cusId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Subscription by subId
         * @param {string} subId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionBySubId(subId: string, options?: any): AxiosPromise<Subscription> {
            return localVarFp.getSubscriptionBySubId(subId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary post payment methods
         * @param {CreatePaymentMethods} [createPaymentMethods] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentMethods(createPaymentMethods?: CreatePaymentMethods, options?: any): AxiosPromise<Customer> {
            return localVarFp.postPaymentMethods(createPaymentMethods, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary post update payment methods
         * @param {CreatePaymentMethods} [createPaymentMethods] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUpdatePaymentMethods(createPaymentMethods?: CreatePaymentMethods, options?: any): AxiosPromise<Customer> {
            return localVarFp.postUpdatePaymentMethods(createPaymentMethods, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update Card
         * @param {UpdateCard} [updateCard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCard(updateCard?: UpdateCard, options?: any): AxiosPromise<Card> {
            return localVarFp.updateCard(updateCard, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update Customer
         * @param {UpdateCustomer} [updateCustomer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(updateCustomer?: UpdateCustomer, options?: any): AxiosPromise<Customer> {
            return localVarFp.updateCustomer(updateCustomer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update Subscription
         * @param {UpdateSubscription} [updateSubscription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(updateSubscription?: UpdateSubscription, options?: any): AxiosPromise<Subscription> {
            return localVarFp.updateSubscription(updateSubscription, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StripeApi - object-oriented interface
 * @export
 * @class StripeApi
 * @extends {BaseAPI}
 */
export class StripeApi extends BaseAPI {
    /**
     * 
     * @summary all Get Coupon
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public allGetCoupon(options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).allGetCoupon(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary all get Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public allGetCustomer(options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).allGetCustomer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary all get Plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public allGetPlan(options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).allGetPlan(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary all get Product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public allGetProduct(options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).allGetProduct(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary all get Promos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public allGetPromos(options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).allGetPromos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary all get Subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public allGetSubscription(options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).allGetSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create Card
     * @param {CreateCard} [createCard] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public createCard(createCard?: CreateCard, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).createCard(createCard, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create Customer
     * @param {CreateCustomer} [createCustomer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public createCustomer(createCustomer?: CreateCustomer, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).createCustomer(createCustomer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create Subscription
     * @param {CreateSubscription} [createSubscription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public createSubscription(createSubscription?: CreateSubscription, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).createSubscription(createSubscription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Card by CusId & CardId
     * @param {string} cusId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public deleteCardByCusIdCardId(cusId: string, cardId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).deleteCardByCusIdCardId(cusId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Customer by cusId
     * @param {string} cusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public deleteCustomerByCusId(cusId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).deleteCustomerByCusId(cusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Subscription by subId
     * @param {string} subId 
     * @param {string} userUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public deleteSubscriptionBySubId(subId: string, userUuid: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).deleteSubscriptionBySubId(subId, userUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Card by Cusid
     * @param {string} cusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getCardByCusId(cusId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getCardByCusId(cusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Card by CusId & CardId
     * @param {string} cusId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getCardByCusIdCardId(cusId: string, cardId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getCardByCusIdCardId(cusId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Coupon by couId
     * @param {string} couId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getCouponByCouId(couId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getCouponByCouId(couId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Customer by cusId
     * @param {string} cusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getCustomerByCusId(cusId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getCustomerByCusId(cusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary post payment methods by cus id
     * @param {string} cusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getPaymentMethodsByCusId(cusId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getPaymentMethodsByCusId(cusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Plan by planId
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getPlanByPlanId(planId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getPlanByPlanId(planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Product by prodId
     * @param {string} prodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getProductByProdId(prodId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getProductByProdId(prodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Promos by promoId
     * @param {string} promoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getPromosByPromoId(promoId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getPromosByPromoId(promoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Subscription by cusId
     * @param {string} cusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getSubscriptionByCusId(cusId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getSubscriptionByCusId(cusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Subscription by subId
     * @param {string} subId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public getSubscriptionBySubId(subId: string, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).getSubscriptionBySubId(subId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary post payment methods
     * @param {CreatePaymentMethods} [createPaymentMethods] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public postPaymentMethods(createPaymentMethods?: CreatePaymentMethods, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).postPaymentMethods(createPaymentMethods, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary post update payment methods
     * @param {CreatePaymentMethods} [createPaymentMethods] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public postUpdatePaymentMethods(createPaymentMethods?: CreatePaymentMethods, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).postUpdatePaymentMethods(createPaymentMethods, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update Card
     * @param {UpdateCard} [updateCard] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public updateCard(updateCard?: UpdateCard, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).updateCard(updateCard, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update Customer
     * @param {UpdateCustomer} [updateCustomer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public updateCustomer(updateCustomer?: UpdateCustomer, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).updateCustomer(updateCustomer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update Subscription
     * @param {UpdateSubscription} [updateSubscription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public updateSubscription(updateSubscription?: UpdateSubscription, options?: AxiosRequestConfig) {
        return StripeApiFp(this.configuration).updateSubscription(updateSubscription, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UgcsApi - axios parameter creator
 * @export
 */
export const UgcsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create ugc
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUGC: async (file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createUGC', 'file', file)
            const localVarPath = `/ugc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get download UGC
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUGC: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getDownloadUGC', 'uuid', uuid)
            const localVarPath = `/ugc/{uuid}/data/bin`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get UGC
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGC: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getUGC', 'uuid', uuid)
            const localVarPath = `/ugc/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read list ugcs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGCs: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ugc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UgcsApi - functional programming interface
 * @export
 */
export const UgcsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UgcsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create ugc
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUGC(file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedUGC>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUGC(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get download UGC
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadUGC(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadUGC(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get UGC
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUGC(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedUGC>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUGC(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Read list ugcs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUGCs(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedUGCList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUGCs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UgcsApi - factory interface
 * @export
 */
export const UgcsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UgcsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create ugc
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUGC(file: any, options?: any): AxiosPromise<EnvelopedUGC> {
            return localVarFp.createUGC(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get download UGC
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUGC(uuid: string, options?: any): AxiosPromise<any> {
            return localVarFp.getDownloadUGC(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get UGC
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGC(uuid: string, options?: any): AxiosPromise<EnvelopedUGC> {
            return localVarFp.getUGC(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read list ugcs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGCs(options?: any): AxiosPromise<EnvelopedPaginatedUGCList> {
            return localVarFp.getUGCs(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UgcsApi - object-oriented interface
 * @export
 * @class UgcsApi
 * @extends {BaseAPI}
 */
export class UgcsApi extends BaseAPI {
    /**
     * 
     * @summary Create ugc
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgcsApi
     */
    public createUGC(file: any, options?: AxiosRequestConfig) {
        return UgcsApiFp(this.configuration).createUGC(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get download UGC
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgcsApi
     */
    public getDownloadUGC(uuid: string, options?: AxiosRequestConfig) {
        return UgcsApiFp(this.configuration).getDownloadUGC(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get UGC
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgcsApi
     */
    public getUGC(uuid: string, options?: AxiosRequestConfig) {
        return UgcsApiFp(this.configuration).getUGC(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read list ugcs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgcsApi
     */
    public getUGCs(options?: AxiosRequestConfig) {
        return UgcsApiFp(this.configuration).getUGCs(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create pre user
         * @param {NewPreUser} newPreUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreUser: async (newPreUser: NewPreUser, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newPreUser' is not null or undefined
            assertParamExists('createPreUser', 'newPreUser', newPreUser)
            const localVarPath = `/user/pre`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newPreUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create pre user by admin
         * @param {NewPreUserByAdmin} newPreUserByAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreUserByAdmin: async (newPreUserByAdmin: NewPreUserByAdmin, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newPreUserByAdmin' is not null or undefined
            assertParamExists('createPreUserByAdmin', 'newPreUserByAdmin', newPreUserByAdmin)
            const localVarPath = `/user/pre/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newPreUserByAdmin, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create special user by admin
         * @param {NewSpecialUserByAdmin} newSpecialUserByAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpecialUserByAdmin: async (newSpecialUserByAdmin: NewSpecialUserByAdmin, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newSpecialUserByAdmin' is not null or undefined
            assertParamExists('createSpecialUserByAdmin', 'newSpecialUserByAdmin', newSpecialUserByAdmin)
            const localVarPath = `/user/admin/special`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newSpecialUserByAdmin, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create user
         * @param {NewUser} newUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (newUser: NewUser, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newUser' is not null or undefined
            assertParamExists('createUser', 'newUser', newUser)
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteUserByUuid', 'uuid', uuid)
            const localVarPath = `/user/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bookmark By UserDetailUuid
         * @param {string} userDetailUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmarkByUserDetailUuid: async (userDetailUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDetailUuid' is not null or undefined
            assertParamExists('getBookmarkByUserDetailUuid', 'userDetailUuid', userDetailUuid)
            const localVarPath = `/user/bookmark/{userDetailUuid}`
                .replace(`{${"userDetailUuid"}}`, encodeURIComponent(String(userDetailUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Complete Material Group By UserDetailUuid
         * @param {string} userDetailUuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleteMaterialGroupByUserDetailUuid: async (userDetailUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDetailUuid' is not null or undefined
            assertParamExists('getCompleteMaterialGroupByUserDetailUuid', 'userDetailUuid', userDetailUuid)
            const localVarPath = `/user/complete-material-group/{userDetailUuid}`
                .replace(`{${"userDetailUuid"}}`, encodeURIComponent(String(userDetailUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Complete Materials By UserDetailUuid
         * @param {string} userDetailUuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleteMaterialsByUserDetailUuid: async (userDetailUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDetailUuid' is not null or undefined
            assertParamExists('getCompleteMaterialsByUserDetailUuid', 'userDetailUuid', userDetailUuid)
            const localVarPath = `/user/complete-materials/{userDetailUuid}`
                .replace(`{${"userDetailUuid"}}`, encodeURIComponent(String(userDetailUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUuid: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getUserByUuid', 'uuid', uuid)
            const localVarPath = `/user/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch bookmark by uuid
         * @param {string} uuid 
         * @param {PatchBookmarkByUuid} patchBookmarkByUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBookmarkByUuid: async (uuid: string, patchBookmarkByUuid: PatchBookmarkByUuid, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('patchBookmarkByUuid', 'uuid', uuid)
            // verify required parameter 'patchBookmarkByUuid' is not null or undefined
            assertParamExists('patchBookmarkByUuid', 'patchBookmarkByUuid', patchBookmarkByUuid)
            const localVarPath = `/user/bookmark/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchBookmarkByUuid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post complete material by uuid
         * @param {string} uuid 
         * @param {PostCompleteMaterial} postCompleteMaterial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompleteMaterialByUuid: async (uuid: string, postCompleteMaterial: PostCompleteMaterial, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('postCompleteMaterialByUuid', 'uuid', uuid)
            // verify required parameter 'postCompleteMaterial' is not null or undefined
            assertParamExists('postCompleteMaterialByUuid', 'postCompleteMaterial', postCompleteMaterial)
            const localVarPath = `/user/complete-material/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCompleteMaterial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post complete materialGroup by uuid
         * @param {string} uuid 
         * @param {PostCompleteMaterialGroup} postCompleteMaterialGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompleteMaterialGroupByUuid: async (uuid: string, postCompleteMaterialGroup: PostCompleteMaterialGroup, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('postCompleteMaterialGroupByUuid', 'uuid', uuid)
            // verify required parameter 'postCompleteMaterialGroup' is not null or undefined
            assertParamExists('postCompleteMaterialGroupByUuid', 'postCompleteMaterialGroup', postCompleteMaterialGroup)
            const localVarPath = `/user/complete-material-group/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCompleteMaterialGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send user registration token
         * @param {EmailWithConfirm} emailWithConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserRegisterToken: async (emailWithConfirm: EmailWithConfirm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailWithConfirm' is not null or undefined
            assertParamExists('sendUserRegisterToken', 'emailWithConfirm', emailWithConfirm)
            const localVarPath = `/user/pre/send-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailWithConfirm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send user registration token by admin
         * @param {EmailWithConfirm} emailWithConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserRegisterTokenByAdmin: async (emailWithConfirm: EmailWithConfirm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailWithConfirm' is not null or undefined
            assertParamExists('sendUserRegisterTokenByAdmin', 'emailWithConfirm', emailWithConfirm)
            const localVarPath = `/user/pre/admin/send-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailWithConfirm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user by uuid
         * @param {string} uuid 
         * @param {UpdateUser} updateUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserByUuid: async (uuid: string, updateUser: UpdateUser, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateUserByUuid', 'uuid', uuid)
            // verify required parameter 'updateUser' is not null or undefined
            assertParamExists('updateUserByUuid', 'updateUser', updateUser)
            const localVarPath = `/user/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authorization_header required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create pre user
         * @param {NewPreUser} newPreUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPreUser(newPreUser: NewPreUser, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPreUserAndToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPreUser(newPreUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create pre user by admin
         * @param {NewPreUserByAdmin} newPreUserByAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPreUserByAdmin(newPreUserByAdmin: NewPreUserByAdmin, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPreUserAndToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPreUserByAdmin(newPreUserByAdmin, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create special user by admin
         * @param {NewSpecialUserByAdmin} newSpecialUserByAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpecialUserByAdmin(newSpecialUserByAdmin: NewSpecialUserByAdmin, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpecialUserByAdmin(newSpecialUserByAdmin, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create user
         * @param {NewUser} newUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(newUser: NewUser, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(newUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Bookmark By UserDetailUuid
         * @param {string} userDetailUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookmarkByUserDetailUuid(userDetailUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedBookmark>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookmarkByUserDetailUuid(userDetailUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Complete Material Group By UserDetailUuid
         * @param {string} userDetailUuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompleteMaterialGroupByUserDetailUuid(userDetailUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedCompleteMaterialGroupList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompleteMaterialGroupByUserDetailUuid(userDetailUuid, limit, offset, direction, column, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Complete Materials By UserDetailUuid
         * @param {string} userDetailUuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompleteMaterialsByUserDetailUuid(userDetailUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedCompleteMaterialList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompleteMaterialsByUserDetailUuid(userDetailUuid, limit, offset, direction, column, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByUuid(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserByUuid(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get users
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedPaginatedUserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(limit, offset, direction, column, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Patch bookmark by uuid
         * @param {string} uuid 
         * @param {PatchBookmarkByUuid} patchBookmarkByUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchBookmarkByUuid(uuid: string, patchBookmarkByUuid: PatchBookmarkByUuid, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedBookmark>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchBookmarkByUuid(uuid, patchBookmarkByUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post complete material by uuid
         * @param {string} uuid 
         * @param {PostCompleteMaterial} postCompleteMaterial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompleteMaterialByUuid(uuid: string, postCompleteMaterial: PostCompleteMaterial, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedCompleteMaterial>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompleteMaterialByUuid(uuid, postCompleteMaterial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post complete materialGroup by uuid
         * @param {string} uuid 
         * @param {PostCompleteMaterialGroup} postCompleteMaterialGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompleteMaterialGroupByUuid(uuid: string, postCompleteMaterialGroup: PostCompleteMaterialGroup, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedCompleteMaterialGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompleteMaterialGroupByUuid(uuid, postCompleteMaterialGroup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary send user registration token
         * @param {EmailWithConfirm} emailWithConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserRegisterToken(emailWithConfirm: EmailWithConfirm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserRegisterToken(emailWithConfirm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary send user registration token by admin
         * @param {EmailWithConfirm} emailWithConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserRegisterTokenByAdmin(emailWithConfirm: EmailWithConfirm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserRegisterTokenByAdmin(emailWithConfirm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user by uuid
         * @param {string} uuid 
         * @param {UpdateUser} updateUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserByUuid(uuid: string, updateUser: UpdateUser, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvelopedUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserByUuid(uuid, updateUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create pre user
         * @param {NewPreUser} newPreUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreUser(newPreUser: NewPreUser, options?: any): AxiosPromise<EnvelopedPreUserAndToken> {
            return localVarFp.createPreUser(newPreUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create pre user by admin
         * @param {NewPreUserByAdmin} newPreUserByAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreUserByAdmin(newPreUserByAdmin: NewPreUserByAdmin, options?: any): AxiosPromise<EnvelopedPreUserAndToken> {
            return localVarFp.createPreUserByAdmin(newPreUserByAdmin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create special user by admin
         * @param {NewSpecialUserByAdmin} newSpecialUserByAdmin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpecialUserByAdmin(newSpecialUserByAdmin: NewSpecialUserByAdmin, options?: any): AxiosPromise<EnvelopedUser> {
            return localVarFp.createSpecialUserByAdmin(newSpecialUserByAdmin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create user
         * @param {NewUser} newUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(newUser: NewUser, options?: any): AxiosPromise<EnvelopedUser> {
            return localVarFp.createUser(newUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserByUuid(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUserByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bookmark By UserDetailUuid
         * @param {string} userDetailUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmarkByUserDetailUuid(userDetailUuid: string, options?: any): AxiosPromise<EnvelopedBookmark> {
            return localVarFp.getBookmarkByUserDetailUuid(userDetailUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Complete Material Group By UserDetailUuid
         * @param {string} userDetailUuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleteMaterialGroupByUserDetailUuid(userDetailUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: any): AxiosPromise<EnvelopedPaginatedCompleteMaterialGroupList> {
            return localVarFp.getCompleteMaterialGroupByUserDetailUuid(userDetailUuid, limit, offset, direction, column, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Complete Materials By UserDetailUuid
         * @param {string} userDetailUuid 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleteMaterialsByUserDetailUuid(userDetailUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: any): AxiosPromise<EnvelopedPaginatedCompleteMaterialList> {
            return localVarFp.getCompleteMaterialsByUserDetailUuid(userDetailUuid, limit, offset, direction, column, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUuid(uuid: string, options?: any): AxiosPromise<EnvelopedUser> {
            return localVarFp.getUserByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {SortDirection} [direction] 
         * @param {string} [column] 
         * @param {boolean} [includeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: any): AxiosPromise<EnvelopedPaginatedUserList> {
            return localVarFp.getUsers(limit, offset, direction, column, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch bookmark by uuid
         * @param {string} uuid 
         * @param {PatchBookmarkByUuid} patchBookmarkByUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBookmarkByUuid(uuid: string, patchBookmarkByUuid: PatchBookmarkByUuid, options?: any): AxiosPromise<EnvelopedBookmark> {
            return localVarFp.patchBookmarkByUuid(uuid, patchBookmarkByUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post complete material by uuid
         * @param {string} uuid 
         * @param {PostCompleteMaterial} postCompleteMaterial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompleteMaterialByUuid(uuid: string, postCompleteMaterial: PostCompleteMaterial, options?: any): AxiosPromise<EnvelopedCompleteMaterial> {
            return localVarFp.postCompleteMaterialByUuid(uuid, postCompleteMaterial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post complete materialGroup by uuid
         * @param {string} uuid 
         * @param {PostCompleteMaterialGroup} postCompleteMaterialGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompleteMaterialGroupByUuid(uuid: string, postCompleteMaterialGroup: PostCompleteMaterialGroup, options?: any): AxiosPromise<EnvelopedCompleteMaterialGroup> {
            return localVarFp.postCompleteMaterialGroupByUuid(uuid, postCompleteMaterialGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send user registration token
         * @param {EmailWithConfirm} emailWithConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserRegisterToken(emailWithConfirm: EmailWithConfirm, options?: any): AxiosPromise<EnvelopedToken> {
            return localVarFp.sendUserRegisterToken(emailWithConfirm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send user registration token by admin
         * @param {EmailWithConfirm} emailWithConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserRegisterTokenByAdmin(emailWithConfirm: EmailWithConfirm, options?: any): AxiosPromise<EnvelopedToken> {
            return localVarFp.sendUserRegisterTokenByAdmin(emailWithConfirm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user by uuid
         * @param {string} uuid 
         * @param {UpdateUser} updateUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserByUuid(uuid: string, updateUser: UpdateUser, options?: any): AxiosPromise<EnvelopedUser> {
            return localVarFp.updateUserByUuid(uuid, updateUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Create pre user
     * @param {NewPreUser} newPreUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createPreUser(newPreUser: NewPreUser, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).createPreUser(newPreUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create pre user by admin
     * @param {NewPreUserByAdmin} newPreUserByAdmin 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createPreUserByAdmin(newPreUserByAdmin: NewPreUserByAdmin, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).createPreUserByAdmin(newPreUserByAdmin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create special user by admin
     * @param {NewSpecialUserByAdmin} newSpecialUserByAdmin 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createSpecialUserByAdmin(newSpecialUserByAdmin: NewSpecialUserByAdmin, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).createSpecialUserByAdmin(newSpecialUserByAdmin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create user
     * @param {NewUser} newUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUser(newUser: NewUser, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).createUser(newUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUserByUuid(uuid: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUserByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bookmark By UserDetailUuid
     * @param {string} userDetailUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getBookmarkByUserDetailUuid(userDetailUuid: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getBookmarkByUserDetailUuid(userDetailUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Complete Material Group By UserDetailUuid
     * @param {string} userDetailUuid 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getCompleteMaterialGroupByUserDetailUuid(userDetailUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getCompleteMaterialGroupByUserDetailUuid(userDetailUuid, limit, offset, direction, column, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Complete Materials By UserDetailUuid
     * @param {string} userDetailUuid 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getCompleteMaterialsByUserDetailUuid(userDetailUuid: string, limit?: number, offset?: number, direction?: SortDirection, column?: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getCompleteMaterialsByUserDetailUuid(userDetailUuid, limit, offset, direction, column, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserByUuid(uuid: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {SortDirection} [direction] 
     * @param {string} [column] 
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUsers(limit?: number, offset?: number, direction?: SortDirection, column?: string, includeDeleted?: boolean, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsers(limit, offset, direction, column, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch bookmark by uuid
     * @param {string} uuid 
     * @param {PatchBookmarkByUuid} patchBookmarkByUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public patchBookmarkByUuid(uuid: string, patchBookmarkByUuid: PatchBookmarkByUuid, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).patchBookmarkByUuid(uuid, patchBookmarkByUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post complete material by uuid
     * @param {string} uuid 
     * @param {PostCompleteMaterial} postCompleteMaterial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public postCompleteMaterialByUuid(uuid: string, postCompleteMaterial: PostCompleteMaterial, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).postCompleteMaterialByUuid(uuid, postCompleteMaterial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post complete materialGroup by uuid
     * @param {string} uuid 
     * @param {PostCompleteMaterialGroup} postCompleteMaterialGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public postCompleteMaterialGroupByUuid(uuid: string, postCompleteMaterialGroup: PostCompleteMaterialGroup, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).postCompleteMaterialGroupByUuid(uuid, postCompleteMaterialGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send user registration token
     * @param {EmailWithConfirm} emailWithConfirm 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public sendUserRegisterToken(emailWithConfirm: EmailWithConfirm, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).sendUserRegisterToken(emailWithConfirm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send user registration token by admin
     * @param {EmailWithConfirm} emailWithConfirm 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public sendUserRegisterTokenByAdmin(emailWithConfirm: EmailWithConfirm, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).sendUserRegisterTokenByAdmin(emailWithConfirm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user by uuid
     * @param {string} uuid 
     * @param {UpdateUser} updateUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserByUuid(uuid: string, updateUser: UpdateUser, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserByUuid(uuid, updateUser, options).then((request) => request(this.axios, this.basePath));
    }
}


